import {
  React,
  useState,
  useLayoutEffect,
  useEffect,
  useCallback,
  useRef,
} from "react";
import {
  CustomGetAPI,
  GetAPI,
  PostAPI,
  CustomPostAPI,
} from "../Utils/APIConnector";
import {
  CheckValidation,
  VenueDate,
  calculatePrice,
  checkTime,
  convertDecimalToTime,
  convertTo12HourFormat,
  convertToISOFormat,
  formatDate,
  formatDateToInput,
  getPriceForTime,
  isWeekend,
  minToHour,
  modifyTime,
  signalRHub,
  timeAddChange,
  timeSubtractChange,
  venueSportsData,
  getSlotIcon,
} from "../Utils/common";
import { DaysOfWeek } from "../Coupon/AddCoupon";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import $ from "jquery";
import { Card } from "react-bootstrap";
import Loader from "../Utils/Loader";
import VerifyPhoneNumber from "../VerifyPhoneNumber";
// import {Tooltip } from 'flowbite-react';
// import { TooltipComponent } from '@syncfusion/ej2-react-popups'
import { OverlayTrigger, Popover } from "react-bootstrap";
import Swal from "sweetalert2";
import { useReactToPrint } from "react-to-print";
import Cookies from "universal-cookie";
import { duration } from "moment";
import AddUserName from "../Popup/AddUserName";
import Popup from "../LiveScoreCardpopups/Popup";
import UseModal from "../Utils/PopupModal/UseModal";
import { result, truncate } from "lodash";
import BulkVenueRequest from "../BulkVenueRequest";

export default function NewVenueBooking({
  venueData,
  isLoading,
  setIsLoading,
  setShow,
  couponsData,
  courtData,
  isPackageBooking,
  selectedPackageId,
  selectedUserPackageId,
  selectedPackageDuration,
  isNearBy,
  showTimeList,
  setShowTimeList,
  setViewAllCoupon,
  showAllCoupon,
  isBulkShow,
  setIsBulkShow,
}) {
  const cookies = new Cookies();
  const Isapp = cookies.get("Isapp");
  const nearbyobj = cookies.get("nearByObj");
  const RequestTime = process.env.REACT_APP_REQUEST_TIME;
  const [hours, setHours] = useState(0);
  const [sendBulkRequest, setSendBulkRequest] = useState(false);

  // const [paymentType, setPaymentType] = useState("Full");
  const username = window.localStorage.getItem("UserName");
  const phoneno = window.localStorage.getItem("phoneno");
  const UserEmail = window.localStorage.getItem("UserEmail");
  const [surfacetype, setsurfacetype] = useState(null);
  const [selectedSurfaceIndex, setSelectedSurfaceIndex] = useState(0);
  const [couponName, setCouponName] = useState("");
  const [isTimeLoader, setIsTimeLoader] = useState(false);
  const [couponApplied, setCouponApplied] = useState(false);
  const [couponError, setErroMsg] = useState({
    errorId: 0,
    errorMsg: "",
    noteMsg: "",
  });
  const [MinSlotTime, setMinSlotTime] = useState(venueData?.minSlotTime);
  const [couponData, setCouponData] = useState(
    []
    // couponsData[0] ? couponsData[0] : null
  );

  const [showSuccess, setShowSuccess] = useState(false);

  const [Duration, setDuration] = useState(null);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [timeDuration, setTimeDuration] = useState(0);
  const [cartCount, setCartCount] = useState(1);
  const [selectedCartCount, setSelectedCartCount] = useState(1);
  const [minutes, setMinutes] = useState(0);
  const [venueSlots, setVenueSlots] = useState([]);
  const params = useParams();
  const navigateToVenuePlace = useNavigate();
  const [surfaceData, setSurfaceData] = useState([]);

  const [showVenueBookingContent, setShowVenueBookingContent] = useState(1);

  const getPreciseDates = (date) => {
    const getday = new Date(date);
    let day = getday.getDay() === 0 ? 7 : getday.getDay();
    let count = 1;
    let PreciseDay;
    if (
      selectedTimeSlots[0]?.startTime.slice(-8) === "23:30:00" &&
      selectedTimeSlots[selectedTimeSlots?.length - 1]?.endTime.slice(-8) >
      "00:00:00"
    ) {
      PreciseDay = day + count;
    } else if (
      selectedTimeSlots[0]?.startTime.slice(-8) === "23:30:00" &&
      selectedTimeSlots[selectedTimeSlots?.length - 1]?.endTime.slice(-8) >
      "00:00:00" &&
      slotDuration === 24.5
    ) {
      PreciseDay = day + count + 1;
    } else if (
      selectedTimeSlots[0]?.startTime.slice(-8) === "23:30:00" &&
      selectedTimeSlots[selectedTimeSlots?.length - 1]?.endTime.slice(-8) >
      "00:00:00" &&
      slotDuration === 24.5
    ) {
      PreciseDay = day + count;
    } else {
      PreciseDay = day;
    }
    return PreciseDay;
  };

  const initialFilterObjects = JSON.parse(
    localStorage.getItem("filterObjects")
  ) || {
    name: "",
    sport: "0",
    timings: [],
    amenities: "0",
    date: new Date().toISOString().slice(0, 10),
    sortby: "0",
  };
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  // const [date, setDate] = useState(
  //   initialFilterObjects?.date
  //     ? initialFilterObjects?.date
  //     : new Date().toISOString().slice(0, 10)
  // );
  const [weekPrice, setWeekPrice] = useState([]);
  const [isEvent, setIsEvent] = useState(false);
  const [availablePackageData, setAvailablePackageData] = useState([]);
  const [usePackageData, setUsePackageData] = useState(false);

  const [slotDuration, setSlotDuration] = useState(venueData?.minSlotTime / 60);
  const [nextAvailableSlots, setNextAvailableSlots] = useState(0);
  const [sportData, setSportData] = useState([]);
  const [venuePrice, setVenuePrice] = useState(0);
  const [venueremainingPrice, setVenueRemainingPrice] = useState(0);
  const [venueconvenience, setVenueConvenience] = useState(0);
  const [showPayment, setShowPayment] = useState(false);
  const [isLoader, setLoader] = useState(false);
  const [selectedTimeSlots, setSelectedTimeSlots] = useState([]);
  const [NumberOfPeople, setNumberOfPeopleAttending] = useState();

  const [showPage, setShowPage] = useState({
    showLogin: false,
    userNameShow: false,
  });
  const [SurfaceSportID, setSurfaceSportID] = useState({
    surface: { id: "", val: "" },
    sport: {
      id: "",
      val: "",
    },
  });
  const [selectedPurpose, setPurpose] = useState(0);
  const [purposeError, setPurposeError] = useState(false);
  const [peopleError, setNumberOfPeopleError] = useState(0);
  const navigate = useNavigate();
  const userID = localStorage.getItem("userid");
  const [showPopover, setShowPopover] = useState(false);
  const [walletBalance, setwalletBalance] = useState();
  const [redeemBalance, setredeemBalance] = useState(false);
  const [invalidCoupons, setInvalidCoupons] = useState([]);

  const overlayRef = useRef(null);
  useEffect(() => {
    const errordiv = document.getElementsByClassName("minSlotTimeError")[0];
    errordiv.classList.add("d-none");
  }, [nextAvailableSlots]);

  const handleslotadditionchange = (e) => {
    setCouponName("");
    setCouponData([]);
    setCouponApplied(false);
    if (isPackageBooking && selectedPackageDuration < slotDuration + 0.5) {
      const errordiv = document.getElementsByClassName("minSlotTimeError")[0];
      errordiv.classList.remove("d-none");
      errordiv.textContent = `Duration cannot be greater than ${selectedPackageDuration} hours`;
      return;
    }
    if (nextAvailableSlots != 0) {
      setNextAvailableSlots((count) => count - 1);
      setSlotDuration((prevDuration) => prevDuration + 0.5);
      const nextslot = venueSlots.filter(
        (venueslot) =>
          venueslot.startTime >
          selectedTimeSlots[selectedTimeSlots.length - 1].startTime
      )[0];
      setSelectedTimeSlots((prevSelected) => [...prevSelected, nextslot]);
    } else {
      if (slotDuration < minToHour(venueData?.minSlotTime)) {
        const errordiv = document.getElementsByClassName("minSlotTimeError")[0];
        errordiv.classList.remove("d-none");
        errordiv.textContent = "Next slot not available";
        return;
      }
    }
  };

  useEffect(() => {
    // const CheckDate = couponsData?.filter(item => new Date(date).setHours(0, 0, 0, 0) >= new Date(item.createdAt).setHours(0, 0, 0, 0))
    // if(CheckDate.length !== 0){
    //   setCouponName(CheckDate?.[0]?.code);
    //   applyCoupon(CheckDate?.[0]?.code, venueData?.id)
    // } else {
    if (selectedTimeSlots.length > 0) {
      if (couponName !== "") {
        applyCoupon(couponName, venueData?.id);
      } else {
        setErroMsg({ errorId: 0, errorMsg: "" });
        setCouponName("");
        setCouponData([]);
        setCouponApplied(false);
      }
    }
    // }
  }, [selectedTimeSlots, date, couponName, slotDuration]);

  useEffect(() => {
    handleDateChange(date);
  }, [isEvent]);
  // useEffect(() => {
  //   if (selectedTimeSlots.length !== 0 && couponApplied) {
  //     setShowSuccess(true);
  //   }
  // }, [selectedTimeSlots.length]);

  // useEffect(() => {
  //   const venueIds = couponData?.venueId?.split(",")?.map((id) => parseInt(id.trim(), 10));
  //   const isIdIncluded = venueIds?.includes(venueData?.id);
  //   const weekdays = couponData?.weekDays?.split(",")?.map(id => parseInt(id));
  //   const isDaysIncluded = DaysOfWeek.filter(item => weekdays?.includes(item?.value))?.map(item => item.label);
  //   const selectedDay = new Date(date).toLocaleDateString('en-US', { weekday : 'short'});
  //   const validateDay = isDaysIncluded?.includes(selectedDay);
  //   const checkPrice = parseInt(venuePrice) <= parseInt(couponData?.amountLimit)

  //   if (isIdIncluded === false) {
  //     setErroMsg({ errorId: 2, errorMsg: "Coupon is not applicable for this venue" });
  //     return;
  //   } else if(validateDay === false && isIdIncluded === true){
  //     setErroMsg({errorId: 2, errorMsg: "Coupon is not available for the selected day"});
  //     return;
  //   } else if(checkPrice && validateDay === true && selectedTimeSlots.length > 0){
  //     setErroMsg({errorId: 2, errorMsg: 'Coupon is not applicable', noteMsg: 'To make the coupon applicable increase the duration time'});
  //     return;
  //   } else if(!checkPrice && validateDay === true){
  //     setErroMsg({errorId: 1, errorMsg: ''});
  //     return;
  //   } else {
  //     setErroMsg({errorId: 2, errorMsg: ''});
  //     return;
  //   }
  // }, [selectedTimeSlots.length, venuePrice, couponData?.amountLimit, date, slotDuration, couponName])

  useEffect(() => {
    if (couponsData) {
      const updatedInvalidCoupons = couponsData
        ?.filter((couponItem) => {
          //Sport Check
          const isSportIncluded = couponItem?.sportIds
            ?.split(",")
            ?.map((id) => Number(id.trim()))
            ?.includes(Number(SurfaceSportID?.sport?.id));

          //Start Date Check
          const isFutureDate =
            new Date(date).setHours(0, 0, 0, 0) >=
            new Date(couponItem?.createdAt).setHours(0, 0, 0, 0);

          //Expiry Date Check
          const isExpired =
            new Date(date).setHours(0, 0, 0, 0) <=
            new Date(couponItem?.expiry).setHours(0, 0, 0, 0);

          //Duration Check
          const isSlotDurationValid =
            couponItem.duration > 0
              ? slotDuration >= couponItem.duration
              : true;

          //In Hours Check
          let isInHours = true;
          if (
            couponItem?.offerEndTime &&
            couponItem?.offerStartTime &&
            selectedTimeSlots?.length
          ) {
            const offerStart = couponItem.offerStartTime;
            const offerEnd = couponItem.offerEndTime;

            const selectedDate = selectedTimeSlots[0]?.startTime?.split("T")[0]; // "2025-10-29"

            const offerStartTime = new Date(`${selectedDate}T${offerStart}`);
            const offerEndTime = new Date(`${selectedDate}T${offerEnd}`);

            const selectedStartTime = new Date(selectedTimeSlots[0]?.startTime);

            const selectedEndTime = new Date(
              selectedTimeSlots[selectedTimeSlots.length - 1]?.endTime?.split(
                "T"
              )[1] == "00:00:00"
                ? selectedTimeSlots[
                  selectedTimeSlots.length - 1
                ]?.startTime?.split("T")[0] + "T23:59:00"
                : selectedTimeSlots[selectedTimeSlots.length - 1]?.endTime
            );

            isInHours =
              selectedStartTime >= offerStartTime &&
              selectedEndTime <= offerEndTime;
          }

          //Venue Id Check
          const venueIds = couponItem?.venueId
            ?.split(",")
            ?.map((id) => parseInt(id.trim(), 10));
          const isIdIncluded =
            venueIds?.length > 0 ? venueIds?.includes(venueData?.id) : true;

          //Weekdays check
          const weekdays = couponItem?.weekDays
            ?.split(",")
            ?.map((id) => parseInt(id));
          const isDaysIncluded = DaysOfWeek.filter((item) =>
            weekdays?.includes(item?.value)
          )?.map((item) => item.label);
          const selectedDay = new Date(date).toLocaleDateString("en-US", {
            weekday: "short",
          });
          const validateDay = isDaysIncluded?.includes(selectedDay);

          //Price Check
          const CalPercentAmount =
            (parseInt(venueremainingPrice) + parseInt(venuePrice)) *
            (couponItem?.offPercentage / 100);
          const checkPrice =
            venueIds?.length > 0
              ? CalPercentAmount < couponItem?.amountLimit
                ? parseInt(venueremainingPrice) <= CalPercentAmount
                : parseInt(venueremainingPrice) <=
                parseInt(couponItem?.amountLimit)
              : CalPercentAmount < couponItem?.amountLimit
                ? parseInt(venuePrice) <= CalPercentAmount
                : parseInt(venuePrice) <= parseInt(couponItem?.amountLimit);

          if (!isSportIncluded) return true;
          if (!isFutureDate) return true;
          if (!isExpired) return true;
          if (!isSlotDurationValid) return true;
          if (!isIdIncluded) return true;
          if (!validateDay && isIdIncluded) return true;
          // if(selectedTimeSlots.length > 0){
          if (checkPrice && validateDay) return true;
          if (!isInHours) return true;
          // }
          // if(couponError.errorId === 2) return true;
          return false;
        })
        .map((coupon) => coupon.code);

      setInvalidCoupons(updatedInvalidCoupons);
    }
  }, [
    selectedTimeSlots.length,
    venuePrice,
    couponData,
    date,
    slotDuration,
    couponName,
    couponsData,
    SurfaceSportID,
  ]);

  const applyCoupon = (name, id) => {
    if (usePackageData) {
      Swal.fire({
        toast: true,
        icon: "warning",
        title: `Coupon can't be applied on package booking!`,
        timer: 3000,
        showConfirmButton: false,
        position: "top",
      });
      return;
    }

    if ((couponName ?? " ").trim() === " ") {
      setErroMsg({ errorId: 0, errorMsg: " " });
      return;
    }

    if (name ? name : couponName) {
      var raw = JSON.stringify({
        Coupon: name ? name : couponName,
        Userid: parseInt(userID),
        Isapp: Isapp ? Isapp : false,
        Venueid: id ? id : 0,
        BookingDate: `${date}T00:00:00`,
        BookingTime:
          selectedTimeSlots.length > 0
            ? `${selectedTimeSlots[0]?.startTime?.slice(11, 16)}`
            : "00:00",
        Duration: slotDuration === 0.5 ? 0 : parseInt(slotDuration),
        SportId: SurfaceSportID.sport.id,
      });

      CustomPostAPI(`/venue/Checkcode`, raw).then((result) => {
        if (result) {
          result = JSON.parse(result);
          if (result.status === "success") {
            setCouponApplied(true);
            setCouponData(result?.data);
            // const couponDiv = document.getElementsByClassName("couponError");
            // const couponDivSuccess =
            // document.getElementsByClassName("couponSuccess");
            // couponDiv[0]?.classList?.add("d-none");
            // couponDivSuccess[0]?.classList?.remove("d-none");
            if (selectedTimeSlots?.length > 0) {
              setShowSuccess(true);
            }
            setErroMsg({ errorId: 1, errorMsg: "" });
          } else if (result.status === "error") {
            setErroMsg({ errorId: 2, errorMsg: result.message });
            setCouponApplied(false);
            setCouponData([]);
            // const couponDiv = document.getElementsByClassName("couponError");
            // couponDiv[0].classList.add("text-danger");
            // couponDiv[0].classList.remove("d-none");
            // couponDiv[0].textContent = result.message;
          } else if (result.status === "Coupon not found.") {
            if ((couponName ?? "").trim() === "") {
              setErroMsg({ errorId: 0, errorMsg: "" });
            } else {
              setErroMsg({ errorId: 2, errorMsg: "Coupon is Invalid." });
            }
            setCouponApplied(false);
            setCouponData([]);

            // const couponDiv = document.getElementsByClassName("couponError");
            // couponDiv[0].classList.add("text-danger");
            // couponDiv[0].classList.remove("d-none");
            // couponDiv[0].textContent = "Coupon not found!";
          } else {
            setErroMsg({ errorId: 2, errorMsg: "" });
            setCouponApplied(false);
            setCouponData([]);
          }
        }
      });
    }
  };
  useEffect(() => {
    function handleClickOutside(event) {
      if (overlayRef.current && !overlayRef.current.contains(event.target)) {
        setShowPopover(false);
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on cleanup
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [overlayRef]);

  const cardRef = useRef(null);

  const handlePrintCard = useReactToPrint({
    content: () => cardRef.current,
  });

  useEffect(() => {
    if (!isNearBy) {
      // if (venueData?.venueSports?.length === 1 && !isNearBy) {
      setSurfaceSportID((prevState) => ({
        ...prevState,
        sport: {
          sport: {
            ...prevState.sport,
            id: venueData?.venueSports[0]?.id,
            val: venueData?.venueSports[0]?.name,
          },
        },
      }));
      setCouponName("");
      setCouponData([]);
      setCouponApplied(false);
      sportsHandle(
        venueData?.venueSports[0]?.id,
        venueData?.venueSports[0]?.name
      );
    }
    // else if (surfaceSportData?.label) {
    //   setSurfaceSportID((prevState) => ({
    //     ...prevState,
    //     sport: {
    //       ...prevState.sport,
    //       id: surfaceSportData?.id ? surfaceSportData?.id : "",
    //       val: surfaceSportData?.label ? surfaceSportData?.label : "",
    //     },
    //   }));
    //   sportsHandle(surfaceSportData?.id);
    // }
  }, []);

  const [paymentStatus, setPaymentStatus] = useState({
    OrderID: "",
    PaymentID: "",
    Status: "",
    loader: false,
  });

  const popover = (
    <Popover
      id="popover-basic"
      style={{ maxWidth: "50%", fontSize: "14px" }}
      onMouseLeave={() => setShowPopover(false)}
    >
      <Popover.Header as="h3">
        You can select multiple time slots
      </Popover.Header>
    </Popover>
  );
  const handleToggle = () => setShowPopover(!showPopover);

  const TimeRef = useRef(null);

  const [MinSlot, setMinSlot] = useState();

  useEffect(() => {
    if (userID && userID > 0) {
      encryptId();
    }
  }, [userID]);
  const encryptId = async () => {
    await CustomGetAPI(`/User/GetEncryptedvalue/${userID}`).then((result) => {
      if (result === undefined || result === "") {
        alert("Something went wrong");
      } else {
        result = JSON.parse(result);

        setwalletBalance(result?.walletBalance);
      }
    });
  };
  useEffect(() => {
    if (selectedTimeSlots?.length > 0) {
      // Calculate and set the total price for the selected time slotss
      const totalPrice = selectedTimeSlots.reduce(
        (acc, selectedSlot) => acc + selectedSlot.price,
        0
      );
      const totalAdvancePrice = selectedTimeSlots.reduce(
        (acc, selectedSlot) =>
          acc + selectedSlot.price * (selectedSlot?.bookingAmount / 100),
        0
      );
      const totalDuration = selectedTimeSlots.length * MinSlotTime;
      var hours = Math.floor(totalDuration / 60);
      var remainingMinutes = totalDuration % 60;
      setHours(hours);
      setMinutes(remainingMinutes);
      const finalPrice = selectedCartCount
        ? totalPrice * selectedCartCount
        : totalPrice;
      let updatedFinalPrice = finalPrice;
      if (updatedFinalPrice === 0 && venueSlots.length > 0) {
        updatedFinalPrice = venueSlots[0]?.price;
      }
      let initAmount = 0;
      if (couponData && totalPrice > 0) {
        initAmount = updatedFinalPrice * (couponData?.offPercentage / 100);
        if (initAmount < couponData?.amountLimit) {
          setDiscountAmount(initAmount);
        } else {
          initAmount = couponData?.amountLimit;
          setDiscountAmount(couponData?.amountLimit);
        }
      }
      // updatedFinalPrice *= venueData?.bookingAmount
      //   ? venueData?.bookingAmount / 100
      //   : 0.2;
      let price =
        totalAdvancePrice -
        (couponData && !couponData?.venueId ? initAmount ?? 0 : 0);

      let topay =
        finalPrice -
        totalAdvancePrice?.toFixed(0) -
        (couponData && couponData?.venueId ? initAmount ?? 0 : 0);
      if (price <= 0 && initAmount > 0 && couponData?.venueId) {
        price = totalAdvancePrice?.toFixed(0);
        topay =
          finalPrice -
          totalAdvancePrice?.toFixed(0) -
          (initAmount ? initAmount : 0);
      }
      if (redeemBalance && price >= 50) {
        price = price - 50;
      }
      // if (!isNaN(price)) {
      //     const numericPrice = parseFloat(price);
      //     setVenuePrice(numericPrice.toFixed(0));
      // }
      if (venueData?.id === 0) {
        setVenuePrice(price?.toFixed(0));
        setVenueRemainingPrice(topay);
      } else {
        setVenuePrice(price?.toFixed(0));
        if (!couponData?.amountLimit) {
          setVenueRemainingPrice(topay);
        } else {
          setVenueRemainingPrice(topay);
        }
      }

      let convenienceFee =
        (parseFloat(price?.toFixed(0)) +
          parseFloat(topay) +
          parseFloat(redeemBalance ? 50 : 0) +
          parseFloat(initAmount ?? 0)) *
        ((parseFloat(venueData?.conveniencePercentage) ?? 0) / 100);
      setVenueConvenience(convenienceFee?.toFixed(0) ?? 0);
    } else if (venueSlots?.length > 0) {
      let totalPrice = venueSlots[0]?.price * (slotDuration * 2);
      const advanceAmount = totalPrice * (venueSlots[0]?.bookingAmount / 100);
      const remainingPrice = totalPrice - advanceAmount;
      let convenienceFee =
        parseFloat(totalPrice ?? 0) *
        ((parseFloat(venueData?.conveniencePercentage) ?? 0) / 100);
      setVenueConvenience(convenienceFee?.toFixed(0) ?? 0);
      setVenuePrice(advanceAmount ?? 0);
      setVenueRemainingPrice(remainingPrice);
    }
  }, [
    selectedTimeSlots,
    selectedCartCount,
    venueSlots,
    couponData,
    redeemBalance,
  ]);

  const isLoggedIn = window.localStorage.getItem("UserMobileNo");
  const UserID = parseInt(window.localStorage.getItem("userid"));
  const userType = window.localStorage.getItem("UserType");

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  const payNow = async (bookingid) => {
    var options;

    const data = JSON.stringify({
      Isfromvenuepayment: true,
      // venueBookings: selectedTimeSlots,
      venueBookings: selectedTimeSlots?.map((slot) => ({
        date: slot.startTime.split("T")[0],
        startTime: slot.startTime.split("T")[1].substring(0, 5),
        endTime: slot.endTime.split("T")[1].substring(0, 5),
        SlotDuration: slotDuration,
        auditoriumEventTypeId:
          selectedPurpose > 0 && selectedPurpose !== "" ? selectedPurpose : 0,
        peopleAttending:
          NumberOfPeople > 0 && NumberOfPeople !== "" ? NumberOfPeople : 0,
      })),
      VenueId: venueData?.id,
      SurfaceId: SurfaceSportID?.surface?.id,
      Date: date,
      Amount: venuePrice,
      UserId: UserID,
      SportId: SurfaceSportID?.sport?.id,
      convertedId: bookingid,
      Duration: timeDuration ? timeDuration : 0,
      NoOfPeople: selectedCartCount ? selectedCartCount : 0,
      IsfromPartialPayment: true,
      CouponId: couponData?.id,
      Discountamount: redeemBalance ? 50 : discountAmount,
      isreferal: redeemBalance,
      PackagePrideId: usePackageData
        ? availablePackageData[0]?.id
        : selectedPackageId,
      Userpackageid: usePackageData
        ? availablePackageData[0]?.packageId
        : selectedUserPackageId,
      ConvenienceFee: venueconvenience,
      TotalAmount:
        selectedTimeSlots.reduce(
          (acc, selectedSlot) => acc + selectedSlot.price,
          0
        ) || 0,
    });
    await CustomPostAPI(
      `${isPackageBooking || usePackageData
        ? `/packages/BookPackageSlot`
        : `/payment/initialize`
      }`,
      data
    ).then((result) => {
      if (result === undefined || result === "") {
        alert("Something went wrong");
      } else {
        result = JSON.parse(result);
        // setIsLoading(true)
        if (result.status === "Success") {
          setShowPayment(false);
          setShow(false);
          setNumberOfPeopleAttending();
          setPurpose(0);
          if (isPackageBooking || usePackageData) {
            Swal.fire({
              icon: "success",
              text: "Your venue booking is confirmed successfully, you will receive notification on your WhatsApp as well as you can check your booking in your account.",
              showConfirmButton: true,
              allowOutsideClick: true,
              confirmButtonText: "View Bookings",
            }).then((result) => {
              if (result.isConfirmed) {
                window.localStorage.setItem(
                  "RedirectURL",
                  window.location.href
                );
                navigate("/venue-booking-details");
              }
            });
            return;
          }
          const order_id = result.orderResponse.orderId;
          const venuepaymentlogid = result.venuepaymentlogid;
          const callback_url =
            "https://cricbuddydevapi.cricbuddy.in/api/payment/Razorpaycallback",
            options = {
              // key: Isapp ? "" : result.orderResponse.razorPayAPIKey,
              amount: result.orderResponse.amount,
              name: "Venue Booking Fee",
              description: "Total_venue_booking_fee",
              image: "https://dev.cricbuddy.in/images/cricketFlash.svg",
              order_id: order_id,
              handler: async (data) => {
                try {
                  window.scrollTo(0, 0);
                  setPaymentStatus((prevState) => ({
                    ...prevState,
                    OrderID: data.razorpay_order_id,
                    PaymentID: data.razorpay_payment_id,
                    loader: true,
                  }));
                  setIsLoading(true);
                  data["Isfromvenuepayment"] = true;
                  data["venuepaymentlogid"] = venuepaymentlogid;
                  data["venueBookings"] = selectedTimeSlots?.map((slot) => ({
                    date: slot.startTime.split("T")[0],
                    startTime: slot.startTime.split("T")[1].substring(0, 5),
                    endTime: slot.endTime.split("T")[1].substring(0, 5),
                  }));
                  data["SurfaceId"] = SurfaceSportID?.surface?.id;
                  data["SportId"] = SurfaceSportID?.sport?.id;
                  data["VenueId"] = venueData?.id;
                  data["Date"] = date;
                  data["BookBy"] = userID;
                  data["convertedId"] = bookingid ? bookingid : "";

                  var paymentData = JSON.stringify(data);
                  const result = await CustomPostAPI(
                    "/payment/confirm",
                    paymentData
                  );

                  if (result === undefined || result === "") {
                    alert("Something went wrong with the payment.");
                  } else {
                    const parsedResult = JSON.parse(result);
                    if (parsedResult?.status === "Error") {
                      Swal.fire({
                        icon: "warning",
                        text: "Selected time slot for Surface and sport is already booked your amount will be refunded in 5-6 business days.",
                        showConfirmButton: true,
                        allowOutsideClick: true,
                        confirmButtonText: "View Bookings",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          window.localStorage.setItem(
                            "RedirectURL",
                            window.location.href
                          );
                          navigate("/venue-booking-details");
                        }
                      });
                    } else {
                      Swal.fire({
                        icon: "success",
                        text: "Your venue booking is confirmed successfully, you will receive notification on your WhatsApp as well as you can check your booking in your account.",
                        showConfirmButton: true,
                        allowOutsideClick: true,
                        confirmButtonText: "View Bookings",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          window.localStorage.setItem(
                            "RedirectURL",
                            window.location.href
                          );
                          navigate("/venue-booking-details");
                        }
                      });
                    }
                    setPaymentStatus((prevState) => ({
                      ...prevState,
                      Status: parsedResult.paymentStatus,
                      loader: false,
                    }));
                    setIsLoading(false);

                    if (bookingid) {
                      setIsLoading(false);
                    }
                    // Handle other success actions if needed
                  }

                  document.body.style.overflow = "auto";
                } catch (error) {
                  // Handle payment failure
                  console.error("Payment failed:", error);
                  CustomGetAPI(
                    `/payment/AddPaymenterror/${error ?? ""}/${userID}`
                  );
                }
              },
              prefill: {
                name: username,
                email: UserEmail ? UserEmail : "",
                contact: phoneno,
              },
              theme: {
                color: "#F3F3F3",
              },
              config: {
                display: {
                  hide: [
                    { method: "paylater" },
                    { method: "netbanking" },
                    { method: "wallet" },
                  ],
                },
              },
              webview_intent: true,

              // redirect: true,
              // callback_url: callback_url,
              timeout: 300,
              modal: {
                ondismiss: function () {
                  document.body.style.overflow = "auto";
                },
              },
            };
          if (!Isapp) {
            options.key = result.orderResponse.razorPayAPIKey;
          }
          if (Isapp) {
            options.amount = options.amount * 100;
            // options.redirect = true;
            // options.callback_url = callback_url;
            const encodedPaymentData = encodeURIComponent(
              JSON.stringify(options)
            );
            window.location.href = `/mobile-booking?paymentData=${encodedPaymentData}`;
          } else {
            const script = document.createElement("script");
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.async = true;
            document.body.appendChild(script);
            const paymentObject = new window.Razorpay(options);
            paymentObject.on("payment.failed", function (response) {
              console.log("error", response);
            });
            paymentObject.open();
          }
        } else {
          var isBooked = document.querySelector(".bookederror");
          isBooked.classList.remove("d-none");
          isBooked.textContent = `${result.message}`;
        }
      }
    });
  };
  const handlePayment = async (isCourtChange) => {
    if (venueData?.category === "Events") {
      if (selectedPurpose === 0) {
        setPurposeError(true);
        setLoader(false);
        return;
      } else {
        setPurposeError(false);
      }
      if (
        NumberOfPeople === null ||
        NumberOfPeople === "" ||
        NumberOfPeople <= 0 ||
        NumberOfPeople === undefined
      ) {
        setNumberOfPeopleError(2);
        setLoader(false);
        return;
      } else if (
        NumberOfPeople > courtData?.data[selectedSurfaceIndex]?.maxcapacity
      ) {
        setNumberOfPeopleError(1);
        setLoader(false);
        return;
      } else {
        setNumberOfPeopleError(0);
      }
    }

    if (slotDuration < minToHour(venueData?.minSlotTime)) {
      const errordiv = document.getElementsByClassName("minSlotTimeError")[0];
      errordiv.classList.remove("d-none");
      errordiv.textContent = `Minimum ${convertDecimalToTime(
        minToHour(venueData?.minSlotTime)
      )} booking is required`;
      setLoader(false);
      return;
    } else {
      const errordiv = document.getElementsByClassName("minSlotTimeError")[0];
      errordiv.classList.add("d-none");
    }
    var isFormValid = CheckValidation({ formID: "payPopup" });
    if (selectedTimeSlots.length > 0) {
      const validTimeSlot = document.querySelector(".selectedtimeslots");

      validTimeSlot.classList.add("d-none");
    } else {
      const validTimeSlot = document.querySelector(".selectedtimeslots");

      validTimeSlot.classList.remove("d-none");
      setLoader(false);
      return;
    }

    if (isFormValid && selectedTimeSlots?.length > 0) {
      if (isLoggedIn === null || isLoggedIn === "") {
        setShowPage({ showLogin: true, userNameShow: false });
        setLoader(false);
        setShowVenueBookingContent(2);
      } else if (!username.trim() || username === "Guest") {
        setShowPage({ showLogin: false, userNameShow: true });
      } else {
        if (!isPackageBooking && !usePackageData) {
          setShowPage({ showLogin: false, userNameShow: false });
          !isCourtChange && setLoader(false);
          setShowVenueBookingContent(2);
        } else {
          payNow();
        }
      }
    }
  };
  const handlerequest = async () => {
    // setIsLoading(true);
    if (slotDuration < minToHour(venueData?.minSlotTime)) {
      const errordiv = document.getElementsByClassName("minSlotTimeError")[0];
      errordiv.classList.remove("d-none");
      errordiv.textContent = `Minimum ${convertDecimalToTime(
        minToHour(venueData?.minSlotTime)
      )} booking is required`;
      return;
    } else {
      const errordiv = document.getElementsByClassName("minSlotTimeError")[0];
      errordiv.classList.add("d-none");
    }
    const isLoggedIn = window.localStorage.getItem("loggedin");
    const UserID = parseInt(window.localStorage.getItem("userid"));

    var isFormValid = CheckValidation({ formID: "payPopup" });
    if (selectedTimeSlots.length > 0) {
      const validTimeSlot = document.querySelector(".selectedtimeslots");

      validTimeSlot.classList.add("d-none");
    } else {
      const validTimeSlot = document.querySelector(".selectedtimeslots");

      validTimeSlot.classList.remove("d-none");
    }

    if (venueData?.category === "Events") {
      if (selectedPurpose === 0) {
        setPurposeError(true);
        setLoader(false);
        return;
      } else {
        setPurposeError(false);
      }
      if (
        NumberOfPeople === null ||
        NumberOfPeople === "" ||
        NumberOfPeople <= 0 ||
        NumberOfPeople === undefined
      ) {
        setNumberOfPeopleError(2);
        setLoader(false);
        return;
      } else if (
        NumberOfPeople > courtData?.data[selectedSurfaceIndex]?.maxcapacity
      ) {
        setNumberOfPeopleError(1);
        setLoader(false);
        return;
      } else {
        setNumberOfPeopleError(0);
      }
    }

    if (isFormValid && selectedTimeSlots?.length > 0) {
      if (isLoggedIn === null || isLoggedIn === "") {
        setShowPage({ showLogin: true, userNameShow: false });
        // setShowVenueBookingContent(2);
      } else if (!username.trim() || username === "Guest") {
        setShowPage({ showLogin: false, userNameShow: true });
      } else {
        // let sendBulkRequest = false;
        // await Swal.fire({
        //   icon: "info",
        //   title: "Do you want to send requests to similar nearby venues?",
        //   showConfirmButton: true,
        //   showCancelButton: true,
        //   confirmButtonText: "Send bulk requests",
        //   cancelButtonText: "Send this venue only",
        //   allowOutsideClick: false,
        //   customClass: {
        //     actions: "swal2-actions-custom",
        //     confirmButton: "swal2-confirm-custom",
        //     cancelButton: "swal2-cancel-custom",
        //   },
        // }).then((result) => {
        //   if (result?.isConfirmed) {
        //     sendBulkRequest = true;
        //   }
        // });
        setLoader(true);
        const data = JSON.stringify({
          Isfromvenuepayment: true,
          // venueBookings: selectedTimeSlots,
          venueBookings: selectedTimeSlots?.map((slot) => ({
            date: slot.startTime.split("T")[0],
            startTime: slot.startTime.split("T")[1].substring(0, 5),
            endTime: slot.endTime.split("T")[1].substring(0, 5),
            SlotDuration: slotDuration,
            auditoriumEventTypeId:
              selectedPurpose > 0 && selectedPurpose !== ""
                ? selectedPurpose
                : 0,
            peopleAttending:
              NumberOfPeople > 0 && NumberOfPeople !== "" ? NumberOfPeople : 0,
          })),
          VenueId: venueData?.id,
          SurfaceId: SurfaceSportID?.surface?.id,
          Date: date,
          Amount: venuePrice,
          BookBy: UserID,
          SportId: SurfaceSportID?.sport?.id,
          packageid: usePackageData
            ? availablePackageData[0]?.id
            : selectedPackageId
              ? selectedPackageId
              : 0,
          Userpackageid: usePackageData
            ? availablePackageData[0]?.packageId
            : selectedUserPackageId,
          sendBulkRequest: sendBulkRequest,
        });
        await CustomPostAPI("/payment/Bookingrequest", data).then(
          async (result) => {
            result = JSON.parse(result);
            let bookingId = result?.id;
            if (result === undefined || result === "") {
              alert("Something went wrong");
            } else {
              if (result.status === "Success") {
                if (venueData?.isAcrive === 6) {
                  setShowVenueBookingContent(3);
                  setShow(false);
                  setNumberOfPeopleAttending();
                  setPurpose(0);
                  setShowPage({ showLogin: false, userNameShow: false });
                  Swal.fire({
                    icon: "success",
                    title: "Request Sent Successfully!",
                    text: "We’ll reach out when we have an update, thank you for your patience.",
                    showConfirmButton: true,
                    showCancelButton: true,
                    cancelButtonText: "Cancel",
                    confirmButtonText: "Near By Venues",
                    // confirmButtonText: sendBulkRequest
                    //   ? "Near By Venues"
                    //   : "Ok",
                  }).then((result) => {
                    if (result.isConfirmed) {
                      // sendBulkRequest
                      //   ? navigate(`/available-venue/${bookingId}`)
                      //   : window.location.reload();
                      navigate(
                        `/nearme?location=${params?.id}&&time=${selectedTimeSlots[0]?.startTime}&&duration=${slotDuration}&&sport=${SurfaceSportID?.sport?.id}`
                      );
                    }
                  });
                  return;
                }
                let timerInterval;
                setPaymentStatus((prevState) => ({
                  ...prevState,
                  loader: false,
                }));
                Swal.fire({
                  title: "Booking request sent. Waiting for venue confirmation.",
                  html: "It may take upto <b></b> minutes.<br/><br/><p class='text-danger'>*Do not close this page until the request is complete.</p>",
                  timer: RequestTime * 60 * 1000,
                  timerProgressBar: true,
                  allowOutsideClick: false,
                  didOpen: () => {
                    Swal.showLoading();
                    const timer = Swal.getPopup().querySelector("b");
                    timerInterval = setInterval(() => {
                      const timeLeft = Swal.getTimerLeft();
                      const minutes = Math.floor(timeLeft / 60000);
                      const seconds = Math.floor((timeLeft % 60000) / 1000);
                      timer.textContent = `${minutes}:${seconds < 10 ? "0" : ""
                        }${seconds}`;
                    }, 100);
                  },
                  willClose: () => {
                    clearInterval(timerInterval);
                  },
                }).then((result) => {
                  /* Read more about handling dismissals below */
                  if (result.dismiss === Swal.DismissReason.timer) {
                    if (sendBulkRequest) {
                      Swal.fire({
                        toast: true,
                        icon: "warning",
                        title:
                          "Sorry, this venue is not available for your selected date and time. Here are other venues which may be available!",
                        timer: 5000,
                        showConfirmButton: false,
                        position: "top",
                      });

                      setIsBulkShow({ popup: true, bookingId: bookingid });
                      signalReq.stop();
                      // return;
                    } else {
                      if (!isPackageBooking && !usePackageData) {
                        Swal.fire({
                          text: "Sorry, this venue is not available for your selected date and time. Here are other venues which may be available!",
                          showConfirmButton: true,
                          showCancelButton: true,
                          showDenyButton: true,
                          denyButtonText: "Select Different Time",
                          cancelButtonText: "Cancel",
                          confirmButtonText: "Near By Venues",
                          // confirmButtonText: sendBulkRequest
                          //   ? "Nearby Venues"
                          //   : "Ok",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            // navigate(`/available-venue/${bookingId}`);
                            signalReq.stop();

                            navigate(
                              `/nearme?location=${params?.id}&&time=${selectedTimeSlots[0]?.startTime}&&duration=${slotDuration}&&sport=${SurfaceSportID?.sport?.id}`
                            );
                          } else if (result.isDenied) {
                            signalReq.stop();
                            setLoader(false);
                            setSelectedTimeSlots([]);
                            return;
                          } else {
                            signalReq.stop();
                            window.location.reload();
                          }
                        });
                      } else {
                        Swal.fire({
                          icon: "error",
                          title:
                            "Sorry, Venue is not available at this time slot!",
                          text: "Please try different day-time slot.",
                          showConfirmButton: true,
                          confirmButtonText: "Ok",
                        }).then((result) => { });
                        setShow(false);
                        setShowVenueBookingContent(3);
                        setNumberOfPeopleAttending();
                        setPurpose(0);
                        setShowPage({ showLogin: false, userNameShow: false });
                        signalReq.stop();
                      }
                    }
                  }
                });
                let bookingid = result.id;
                const signalReq = await signalRHub(bookingid);
                signalReq.on("ReceiveStatus", (message) => {
                  setLoader(false);
                  if (message.status === "accepted") {
                    setShowVenueBookingContent(3);
                    setShow(false);
                    setNumberOfPeopleAttending();
                    setPurpose(0);
                    setShowPage({ showLogin: false, userNameShow: false });
                    if (!isPackageBooking && !usePackageData) {
                      Swal.fire({
                        icon: "info",
                        title: "Your request has been accepted!",
                        text: "Click Pay Now to complete Payment",
                        showConfirmButton: true,
                        showCancelButton: true,
                        allowOutsideClick: false,
                        confirmButtonText: "Pay Now",
                        cancelButtonText: "Cancel",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          payNow(bookingid);
                          Swal.close();
                        }
                      });
                    } else {
                      Swal.fire({
                        icon: "success",
                        title: "Your booking is confirmed!",
                        showConfirmButton: true,
                        confirmButtonText: "View Bookings",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          window.localStorage.setItem(
                            "RedirectURL",
                            window.location.href
                          );
                          navigate("/venue-booking-details");
                        } else {
                          window.location.reload();
                        }
                      });
                    }
                  } else if (!isPackageBooking && !usePackageData) {
                    if (
                      message?.data?.selectedSurface > 0 ||
                      message?.data?.selectedSlots?.length > 0
                    ) {
                      if (message?.data?.selectedSurface) {
                        Swal.fire({
                          // icon: "info",
                          // title: "Time Slot Unavailable For Selected Turf",
                          html: `
  <p>Your selected court/turf is booked but venue has another court/turf available for your time slot. Continue with booking?</p>
  <form id="slot-form">
    
  </form>
`,
                          showDenyButton: true,
                          denyButtonText: "Select Different Time",
                          cancelButtonText: "Cancel",
                          showConfirmButton: true,
                          confirmButtonText: "Continue",
                          showCancelButton: true,
                          cancelButtonText: "Cancel",
                        }).then((result) => {
                          if (
                            result.isConfirmed &&
                            result.value !== undefined
                          ) {
                            surfaceHandle(message?.data?.selectedSurface, true);
                            setLoader(false);
                            setLoader(true);
                            handlePayment(true);
                          } else if (result.isDenied) {
                            setSelectedTimeSlots([]);
                            return;
                          } else {
                            window.location.reload();
                          }
                        });
                      } else {
                        Swal.fire({
                          // icon: "info",
                          // title: "Time Slot Unavailable",
                          html: `
  <p>Your selected time slot is booked but venue owner has suggested few other slots which are available.</p>
  <form id="slot-form">
    <ul style="text-align:center; list-style:none; padding:0;">
      ${message?.data?.selectedSlots
                              ?.map((s, i) => {
                                const [start, end] = s.split("to");
                                const startStr = new Date(start).toLocaleString([], {
                                  year: "numeric",
                                  month: "short",
                                  day: "2-digit",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,
                                });
                                const endStr = new Date(end).toLocaleString([], {
                                  year: "numeric",
                                  month: "short",
                                  day: "2-digit",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,
                                });
                                return `
           <li class="mb-3 d-flex align-items-start justify-content-center" style="margin:5px 0; gap:8px;">
            <input type="radio" name="slot" value="${i}" id="slot-radio-${i}" class="mt-2" />
             <label for="slot-radio-${i}" style="cursor:pointer; margin-bottom:0;">
              ${startStr} - ${window.innerWidth < 900 ? "<br />" : ""} ${endStr}
             </label>
           </li>
          `;
                              })
                              .join("")}
    </ul>
  </form>
`,
                          showDenyButton: true,
                          denyButtonText: "Select Different Time",
                          cancelButtonText: "Cancel",
                          showConfirmButton: true,
                          confirmButtonText: "Continue",
                          showCancelButton: true,
                          cancelButtonText: sendBulkRequest
                            ? "Nearby Venues"
                            : "Cancel",
                          preConfirm: () => {
                            const selectedRadio = document.querySelector(
                              'input[name="slot"]:checked'
                            );
                            if (!selectedRadio) {
                              Swal.showValidationMessage(
                                "Please select a slot."
                              );
                              return false;
                            }
                            return selectedRadio.value;
                          },
                        }).then((result) => {
                          if (
                            result.isConfirmed &&
                            result.value !== undefined
                          ) {
                            const index = result.value;
                            const selected =
                              message?.data?.selectedSlots[index];
                            const [startStr] = selected?.split("to");
                            const matchedIndex = venueSlots?.findIndex(
                              (slot) =>
                                new Date(slot.startTime).getTime() ===
                                new Date(startStr).getTime()
                            );
                            if (matchedIndex !== -1) {
                              setNextAvailableSlots(0);
                              const selectedSlots = venueSlots.slice(
                                matchedIndex,
                                matchedIndex + slotDuration * 2
                              );
                              setSelectedTimeSlots(selectedSlots);
                              const selectedDate =
                                selectedSlots[0]?.startTime?.split("T")[0];
                              if (selectedDate !== date) {
                                setDate(selectedDate);
                              }
                              setLoader(true);
                              handlePayment();
                            } else {
                              setSelectedTimeSlots([]);
                            }
                            setLoader(false);
                          } else if (result.isDenied) {
                            setSelectedTimeSlots([]);
                            return;
                          } else {
                            if (sendBulkRequest) {
                              navigate(`/available-venue/${bookingId}`);
                            } else {
                              window.location.reload();
                            }
                          }
                        });
                      }
                    } else {
                      if (sendBulkRequest) {
                        Swal.fire({
                          toast: true,
                          icon: "warning",
                          title:
                            "Sorry, this venue is not available for your selected date and time. Here are other venues which may be available!",
                          timer: 5000,
                          showConfirmButton: false,
                          position: "top",
                        });

                        setIsBulkShow({ popup: true, bookingId: bookingid });
                        signalReq.stop();
                        // return;
                      } else {
                        Swal.fire({
                          // icon: "error",
                          // title:
                          //   "Sorry, Venue is not available at this time slot!",
                          text: "Sorry, this venue is not available for your selected date and time. Here are other venues which may be available!",
                          showDenyButton: true,
                          denyButtonText: "Select Different Time",
                          cancelButtonText: "Cancel",
                          showConfirmButton: true,
                          showCancelButton: true,
                          cancelButtonText: "Cancel",
                          confirmButtonText: "Near By Venues",
                          // confirmButtonText: sendBulkRequest
                          //   ? "Nearby Venues"
                          //   : "Ok",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            // navigate(`/available-venue/${bookingId}`);
                            navigate(
                              `/nearme?location=${params?.id}&&time=${selectedTimeSlots[0]?.startTime}&&duration=${slotDuration}&&sport=${SurfaceSportID?.sport?.id}`
                            );
                          } else if (result.isDenied) {
                            setSelectedTimeSlots([]);
                            return;
                          } else {
                            window.location.reload();
                          }
                        });
                      }
                    }
                  } else {
                    Swal.fire({
                      icon: "error",
                      title: "Sorry, Venue is not available at this time slot!",
                      text: "Please try different day-time slot.",
                      showConfirmButton: true,
                      confirmButtonText: "Ok",
                    }).then((result) => { });
                  }
                  signalReq.stop();
                });
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Please try again later!",
                  text: "Your request has failed.",
                  showConfirmButton: true,
                  confirmButtonText: "Ok",
                }).then((result) => {
                  if (result.isConfirmed) {
                    // window.location.reload();
                  }
                });
              }
            }
          }
        );
        // setShowPayment(true);
      }
    }
  };

  useEffect(() => {
    //set initial date and time
    const initialDate = getPreciseDates(date);

    //get selected start and end day
    const getStartday = new Date(selectedTimeSlots[0]?.startTime.slice(0, 10));
    const selectedStartDate =
      getStartday.getDay() === 0 ? 7 : getStartday.getDay();

    const getEndDay = new Date(
      selectedTimeSlots[selectedTimeSlots.length - 1]?.endTime.slice(0, 10)
    );
    const selectedEndDate = getEndDay.getDay() === 0 ? 7 : getEndDay.getDay();

    let AllDatesData = [];

    //filter available data
    const FilterOutAvailable = courtData.packageDetailsList.filter(
      (item) => item.ispackageAvailable === true
    );
    //flatten the data
    const FlattenData = FilterOutAvailable.flatMap((item) =>
      item.packagePriceData.map((data) => ({
        ...data,
        name: item.name,
      }))
    );

    // check if the selected or initial day is included in weekdays
    const IncludesInitialDate = FlattenData.filter((items) =>
      items.weekDays?.includes(initialDate > 7 ? 1 : initialDate)
    );
    const IncludesStartDate = FlattenData.filter((items) =>
      items.weekDays?.includes(selectedStartDate > 7 ? 1 : selectedStartDate)
    );
    const IncludesEndDate = FlattenData.filter((items) =>
      items.weekDays?.includes(selectedEndDate > 7 ? 1 : selectedEndDate)
    );

    //store them in a array
    AllDatesData =
      IncludesStartDate && IncludesEndDate
        ? [...IncludesStartDate, IncludesEndDate].flat()
        : [...IncludesInitialDate].flat();

    // get Precise End Time for comparison
    const SetEndTime =
      selectedTimeSlots[selectedTimeSlots?.length - 1]?.endTime;

    //filter out duplicate values
    const FilterDuplicate = AllDatesData.filter(
      (items, index) => AllDatesData.indexOf(items) === index
    );
    //get final available packages
    const getFinalAvailPackage = FilterDuplicate?.filter((toCheck) => {
      const slotDate = selectedTimeSlots[0]?.startTime.slice(0, 10);

      const slotStartDate = new Date(`${slotDate} ${toCheck?.startTime}`);
      let slotEndDate = new Date(`${slotDate} ${toCheck?.endTime}`);

      // Handle slots that cross midnight

      // Handle selected time
      const selectedStart = new Date(selectedTimeSlots[0]?.startTime);
      const selectedEnd = new Date(SetEndTime);

      // If selected time is midnight (00:00), ensure it fits within the range
      const isMidnightSelected =
        selectedStart.getHours() === 0 && selectedStart.getMinutes() === 0;
      if (!isMidnightSelected && slotEndDate <= slotStartDate) {
        slotEndDate.setDate(slotEndDate.getDate() + 1);
      }
      if (isMidnightSelected) {
        slotStartDate.setDate(slotStartDate.getDate() - 1);
      }
      // Ensure slots with the same start and end times are valid
      const isSameTime = toCheck?.startTime === toCheck?.endTime;
      const durationCheck = toCheck?.remainingDuration < slotDuration;
      return (
        !durationCheck &&
        (isSameTime ||
          (isMidnightSelected &&
            slotStartDate <= selectedStart &&
            slotEndDate >= selectedEnd) ||
          (slotStartDate <= selectedStart && slotEndDate >= selectedEnd))
      );
    });

    if (getFinalAvailPackage?.length < 1) {
      setUsePackageData(false);
    }
    setAvailablePackageData(getFinalAvailPackage);
  }, [
    date,
    courtData.packageDetailsList,
    selectedTimeSlots,
    selectedTimeSlots.length,
    slotDuration,
  ]);

  const surfaceHandle = (val, isSurfaceChange = false) => {
    const selectedOption = $("#selectSurfaceName")
      .find("option:selected")
      .attr("data-name");
    setSurfaceSportID((prevState) => ({
      ...prevState,
      surface: { ...prevState.surface, id: val, val: selectedOption },
    }));
    getData(val);
    if (isSurfaceChange) {
      setNextAvailableSlots(0);
      gettime(date, SurfaceSportID?.sport?.id, val, false, true);
      return;
    }
    // setDate(new Date().toISOString().slice(0, 10));
    setCouponName("");
    setCouponData([]);
    setCouponApplied(false);
    setVenueSlots([]);
    setShowTimeList((prevState) => ({ ...prevState, value: "" }));
    if (MinSlotTime === 30) {
      setHours(0);
      setMinutes(30);
    } else if (MinSlotTime === 60) {
      setHours(1);
      setMinutes(0);
    } else if (MinSlotTime === 90) {
      setHours(1);
      setMinutes(30);
    }
    setSelectedTimeSlots([]);
    setSlotDuration(venueData?.minSlotTime / 60);
    setNextAvailableSlots(0);
    gettime(date, SurfaceSportID?.sport?.id, val);
    // setVenuePrice(0);
  };

  const getData = async (val) => {
    await CustomGetAPI(`/Venue/GetPrices/${venueData?.id}/0/${val}`).then(
      (result) => {
        if (result === undefined || result === "") {
          alert("Something went wrong");
        } else {
          result = JSON.parse(result);
          if (result?.status === "Success") {
            setSurfaceData(result?.surfaceSport?.data);
          }
        }
      }
    );
  };

  const handleTimeChange = (e) => {
    if (
      SurfaceSportID?.surface.id != "" &&
      SurfaceSportID?.surface?.id != "0"
    ) {
      setShowTimeList((prevState) => ({
        ...prevState,
        show: !prevState?.show,
      }));
      setCouponName("");
      setCouponData([]);
      setCouponApplied(false);
    }
  };

  const handleDateChange = async (val) => {
    setDate(val);
    if (MinSlotTime === 30) {
      setHours(0);
      setMinutes(30);
    } else if (MinSlotTime === 60) {
      setHours(1);
      setMinutes(0);
    } else if (MinSlotTime === 90) {
      setHours(1);
      setMinutes(30);
    }
    // setVenuePrice(0);
    let weeks = [];
    if (!isPackageBooking) {
      if (!isWeekend(val)) {
        //sat-sun
        weeks = sportData?.prices[0]?.prices;
      } else {
        //mon-fri
        weeks = sportData?.prices[1]?.prices;
      }
    } else {
      weeks = 1;
    }

    setWeekPrice(weeks);
    setSelectedTimeSlots([]);
    setCouponName("");
    setCouponData([]);
    setCouponApplied(false);
    setErroMsg({ errorId: 0, errorMsg: "" });
    setSlotDuration(venueData?.minSlotTime / 60);
    setNextAvailableSlots(0);
    gettime(val, SurfaceSportID?.sport?.id);
  };

  async function gettime(
    val,
    sportid,
    surfaceId,
    nearByPage = false,
    isSurfaceChange = false
  ) {
    setIsTimeLoader(true);
    await CustomGetAPI(
      isPackageBooking
        ? `/Packages/GetPackageTimeslots/${venueData?.id}/${sportid ? sportid : SurfaceSportID?.sport?.id
        }/${surfaceId ? surfaceId : SurfaceSportID?.surface?.id}/${timeDuration ? timeDuration : 0
        }/${isEvent}/false/${selectedPackageId}?date=${val ? val : date}`
        : `/Venue/GetTimeslots/${venueData?.id}/${sportid ? sportid : SurfaceSportID?.sport?.id
        }/${surfaceId ? surfaceId : SurfaceSportID?.surface?.id}/${timeDuration ? timeDuration : 0
        }/${isEvent}/false?date=${val ? val : date}`
    ).then((result) => {
      if (result === undefined || result === "") {
        // alert("Something went wrong");
      } else {
        result = JSON.parse(result);
        if (result?.length > 0) {
          setVenueSlots(result);
          if (isSurfaceChange) {
            const matchedIndex = result?.findIndex(
              (slot) =>
                new Date(slot.startTime).getTime() ===
                new Date(selectedTimeSlots[0]?.startTime).getTime()
            );
            if (matchedIndex !== -1) {
              setNextAvailableSlots(0);
              const selectedSlots = result.slice(
                matchedIndex,
                matchedIndex + slotDuration * 2
              );
              setSelectedTimeSlots(selectedSlots);
            } else {
              setSelectedTimeSlots([]);
            }
            setLoader(false);
            return;
          }
          // if (venueSlots.length > 0) {
          //   setSelectedTimeSlots([venueSlots[0]]);
          // }
          // setSelectedTimeSlots(result[0]);
          setShowTimeList((prevState) => ({
            ...prevState,
            value: result[0]?.startTimeString,
          }));
          // if (nearByPage) {
          //   let slotDate = nearbyobj?.dateTime;
          //   const availableSlot = result.filter(
          //     (data) => data?.startTime === slotDate && !data?.booked
          //   );
          //   if (availableSlot?.length > 0) {
          //     handleTimeSlot(availableSlot[0], result);
          //   }
          // }
          // let price = getPriceForTime(result[0]?.startTime, weeks);
          // setVenuePrice(price);
        } else if (result.length === 0) {
          setVenueSlots([]);
        }
      }
    });
    setIsTimeLoader(false);
  }

  const sportsHandle = (val, label, newDate, nearByPage) => {
    // setDate(new Date().toISOString().slice(0, 10));
    const selectedOption = $("#selectSportsName")
      .find("option:selected")
      .attr("data-name");
    setSurfaceSportID((prevState) => ({
      ...prevState,
      sport: {
        ...prevState.sport,
        id: val,
        val: selectedOption ? selectedOption : label,
      },
    }));
    setCouponName("");
    setCouponData([]);
    setCouponApplied(false);
    setVenueSlots([]);
    setsurfacetype([]);
    setShowTimeList((prevState) => ({ ...prevState, value: "" }));
    let sportData = surfaceData?.find((item) => item.id === parseInt(val));
    setSportData(sportData);
    setSelectedTimeSlots([]);
    setSlotDuration(venueData?.minSlotTime / 60);
    setNextAvailableSlots(0);
    if (val != 0) {
      CustomGetAPI(`/venue/Getsurfaces/${venueData?.id}/${val}`).then(
        (result) => {
          if (result === undefined || result === "") {
            alert("Something went wrong");
          } else {
            result = JSON.parse(result);
            if (result?.status === "Success") {
              setDuration(result?.duration);
              setTimeDuration(result?.duration[0]?.time);
              setCartCount(result?.noOfCarts);
              setsurfacetype(result.response);
              setSurfaceSportID((prevState) => ({
                ...prevState,
                surface: {
                  ...prevState.surface,
                  id: result.response[0].surfaceid,
                  val: result.response[0].surfacename,
                },
              }));
              gettime(
                newDate ? newDate : date,
                parseInt(val),
                result.response[0].surfaceid,
                nearByPage
              );
            }
          }
        }
      );
    }
  };

  const handleTimeSlot = (slots, result) => {
    if (!slots?.booked) {
      if (MinSlotTime === 30) {
        setHours(0);
        setMinutes(30);
      } else if (MinSlotTime === 60) {
        setHours(1);
        setMinutes(0);
      } else if (MinSlotTime === 90) {
        setHours(1);
        setMinutes(30);
      }
      let count = 0;
      const selectedStartTime = slots?.startTime;
      const sevenPm = `${selectedStartTime?.split("T")[0]}T19:00:00`;
      if (result && result?.length > 0) {
        for (let i = 0; i < result.length; i++) {
          const venueslot = result[i];

          // Check if the slot's start time is after the selected start time
          if (venueslot.startTime > selectedStartTime) {
            if (!venueslot.booked) {
              if (
                new Date(selectedStartTime) < new Date(sevenPm) &&
                venueData?.id == process.env.REACT_APP_STUDIO_ID
              ) {
                if (new Date(venueslot.startTime) < new Date(sevenPm)) {
                  count++;
                } else {
                  break;
                }
              } else {
                count++;
              }
            } else {
              break;
            }
          }
        }
        // setSlotDuration(parseFloat(nearbyobj?.slotDuration));
      } else {
        for (let i = 0; i < venueSlots.length; i++) {
          const venueslot = venueSlots[i];

          // Check if the slot's start time is after the selected start time
          if (venueslot.startTime > selectedStartTime) {
            if (!venueslot.booked) {
              if (
                new Date(selectedStartTime) < new Date(sevenPm) &&
                venueData?.id == process.env.REACT_APP_STUDIO_ID
              ) {
                if (new Date(venueslot.startTime) < new Date(sevenPm)) {
                  count++;
                } else {
                  break;
                }
              } else {
                count++;
              }
            } else {
              break;
            }
          }
        }
        setSlotDuration(venueData?.minSlotTime / 60);
      }
      let minTimeSlot = MinSlotTime / 30;
      if (minTimeSlot > count + 1) {
        Swal.fire({
          toast: true,
          icon: "warning",
          title: `Minimum ${convertDecimalToTime(
            minToHour(venueData?.minSlotTime)
          )} booking is required`,
          timer: 3000,
          showConfirmButton: false,
          position: "top",
        });
        setSlotDuration(venueData?.minSlotTime / 60);
        setNextAvailableSlots(0);
        setSelectedTimeSlots([]);
        return;
      }
      setSelectedTimeSlots((prevSelected) => {
        const isSlotSelected =
          prevSelected.length > 0 &&
          prevSelected[0].startTimeString === slots.startTimeString;

        // if (isSlotSelected) {
        //   return [];
        // } else {
        setShowTimeList((prevState) => ({
          ...prevState,
          show: false,
        }));
        let selectedIndex = result?.findIndex(
          (data) => data?.startTime === slots?.startTime
        );
        let newSelected = result?.slice(
          selectedIndex,
          selectedIndex + minTimeSlot
          // (nearbyobj
          //   ? parseFloat(nearbyobj?.slotDuration, 10) * 2
          //   : minTimeSlot)
        );

        return result && result?.length > 0 ? newSelected : [slots];
        // }
      });
      setSlotDuration(minTimeSlot / 2);
      setNextAvailableSlots(count + 1 - minTimeSlot);

      // Toggle the selected state of the time slot
    }

    // let price = getPriceForTime(slots?.startTime, weekPrice);
    // setVenuePrice(price);
  };

  useEffect(() => {
    if (MinSlotTime === 30) {
      setHours(0);
      setMinutes(30);
    } else if (MinSlotTime === 60) {
      setHours(1);
      setMinutes(0);
    } else if (MinSlotTime === 90) {
      setHours(1);
      setMinutes(30);
    }
  }, [MinSlotTime]);

  // useEffect(() => {
  //   function handleClickOutside(ref) {
  //     return function (event) {
  //       if (ref.current && !ref.current.contains(event.target)) {
  //         setShowTimeList((prevState) => ({ ...prevState, show: false }));
  //       }
  //     };
  //   }
  //   const handleTimeClick = handleClickOutside(TimeRef);
  //   document.addEventListener("mousedown", handleTimeClick);

  //   return () => {
  //     document.removeEventListener("mousedown", handleTimeClick);
  //   };
  // }, [TimeRef]);

  useEffect(() => {
    if (timeDuration && SurfaceSportID?.surface?.id) {
      gettime();
    }
  }, [timeDuration, SurfaceSportID?.surface?.id]);

  useEffect(() => {
    if (isNearBy) {
      setDate(
        new Date(nearbyobj?.dateTime?.split("T")[0]) <= new Date()
          ? formatDateToInput(new Date())
          : nearbyobj?.dateTime?.split("T")[0]
      );
      setSurfaceSportID((prevState) => ({
        ...prevState,
        sport: {
          sport: {
            ...prevState.sport,
            id: nearbyobj?.selectedSport,
            val: nearbyobj?.selectedSport,
          },
        },
      }));

      sportsHandle(
        nearbyobj?.selectedSport,
        nearbyobj?.selectedSport,
        nearbyobj?.dateTime?.split("T")[0],
        true
      );
    }
  }, []);

  return (
    <>
      {paymentStatus.loader || isLoading ? (
        <Loader mt="20%" />
      ) : (
        <>
          {showPage?.showLogin ? (
            <VerifyPhoneNumber
              setShowPage={setShowPage}
              // setshowpayment={setShowPayment}
              isfromvenueowner={false}
              isActive={venueData?.isAcrive}
              handlerequest={handlerequest}
            />
          ) : showPage?.userNameShow ? (
            <AddUserName
              show={showPage?.userNameShow}
              setShowPage={setShowPage}
              setShowVenueBookingContent={setShowVenueBookingContent}
            />
          ) : (
            <>
              {paymentStatus.Status === "" && (
                <div>
                  {showVenueBookingContent === 1 ? (
                    <>
                      <div className="px-md-3">
                        <h5 className="colorClass text-center">
                          Booking Details
                        </h5>
                        {isPackageBooking && (
                          <div className="venueText text-center">
                            {" "}
                            <span>Please choose from applicable days</span>
                          </div>
                        )}
                        <div className="mt-4 parent" id="payPopup">
                          <div className="row mt-3">
                            <div className="col-4">
                              <span className="venueText">
                                {courtData?.data[0]?.category}
                              </span>
                            </div>
                            <div className="col-8 parent">
                              <select
                                id="selectSportsName"
                                required
                                className="customize-select"
                                aria-label="Select Sports"
                                name=""
                                onChange={(e) => {
                                  sportsHandle(e.target.value);
                                }}
                                value={SurfaceSportID?.sport?.id}
                                disabled={
                                  venueData?.venueSports?.length === 1 ||
                                  venueData?.venueSports === null
                                }
                                style={{
                                  background:
                                    venueData?.venueSports?.length === 1 ||
                                      venueData?.venueSports === null
                                      ? "#F7F7F7"
                                      : "",
                                  opacity:
                                    venueData?.venueSports?.length === 1 ||
                                      venueData?.venueSports === null
                                      ? "0.4"
                                      : "1",
                                  lineHeight: "1.7",
                                }}
                              >
                                <option value="0">Select Sports</option>

                                {venueData?.venueSports?.map((data, i) => (
                                  <option
                                    key={data?.id}
                                    value={data?.id}
                                    data-name={data?.name}
                                    selected={
                                      venueData?.venueSports?.length === 1 &&
                                      i === 0
                                    }
                                  >
                                    {data?.name}
                                  </option>
                                ))}
                              </select>
                              <span className="form-text invalid-feedback">
                                * This field is Required!
                              </span>
                            </div>
                          </div>
                          <div className="row mt-3">
                            <div className="col-4">
                              <span className="venueText">
                                {courtData?.data[0]?.category === "Sports"
                                  ? "Court/Surface"
                                  : "Space"}
                              </span>
                            </div>
                            <div className="col-8 parent">
                              <select
                                id="selectSurfaceName"
                                required
                                className="customize-select"
                                style={{
                                  background:
                                    surfacetype?.length < 2 ||
                                      surfacetype === null
                                      ? "#F7F7F7"
                                      : "",
                                  opacity:
                                    surfacetype?.length < 2 ||
                                      surfacetype === null
                                      ? "0.4"
                                      : "1",
                                }}
                                aria-label="Select Sports"
                                onChange={(e) => {
                                  surfaceHandle(e.target.value);
                                  setSelectedSurfaceIndex(
                                    e.target.selectedIndex - 1
                                  );
                                }}
                                name=""
                                value={SurfaceSportID?.surface?.id}
                                disabled={
                                  surfacetype?.length < 2 ||
                                  surfacetype === null
                                }
                              >
                                <option value="0">
                                  Select{" "}
                                  {courtData?.data[0]?.category === "Sports"
                                    ? "Surface"
                                    : "Event"}
                                </option>
                                {surfacetype?.map((surface, i) => (
                                  <option
                                    value={surface.surfaceid}
                                    data-name={surface?.surfacename}
                                    data-id={i}
                                    selected={
                                      surfacetype.length === 1 && i === 0
                                    }
                                  >
                                    {surface.surfacename}
                                  </option>
                                ))}
                              </select>
                              <span className="form-text invalid-feedback">
                                * This field is Required!
                              </span>
                            </div>
                          </div>
                          {SurfaceSportID?.sport?.val === "Auditorium" &&
                            SurfaceSportID?.surface?.id != 0 &&
                            courtData?.data[selectedSurfaceIndex]
                              ?.isrehearsal && (
                              <div className="row mt-3">
                                <div className="col-12">
                                  <span className="venueText">
                                    Are you booking for rehearsal?
                                  </span>
                                </div>
                                <div className="col-8 parent">
                                  <div className="row">
                                    <div className="col-md-3 col-4 my-1">
                                      <input
                                        type="radio"
                                        name="isEvent"
                                        value="yes"
                                        id="yes"
                                        className="form-check-input me-1 "
                                        onClick={(e) => {
                                          setIsEvent(true);
                                        }}
                                        checked={isEvent}
                                      />
                                      <label
                                        htmlFor="yes"
                                        className="venueText"
                                      >
                                        Yes
                                      </label>
                                    </div>
                                    <div className="col-md-4 col-6 my-1">
                                      <input
                                        type="radio"
                                        name="isEvent"
                                        value="no"
                                        id="no"
                                        className="form-check-input me-1 "
                                        onClick={(e) => {
                                          setIsEvent(false);
                                        }}
                                        checked={!isEvent}
                                      />
                                      <label htmlFor="no" className="venueText">
                                        No
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                          <div className="row mt-3">
                            <div className="col-12 mb-2">
                              <span className="venueText">Date & Time</span>
                            </div>
                            <div className="col-6 parent">
                              <input
                                type="date"
                                min={new Date().toJSON().slice(0, 10)}
                                required
                                className="form-control"
                                id="dateInput"
                                style={{
                                  background: "#F7F7F7",
                                  opacity:
                                    SurfaceSportID?.surface?.id === "" ||
                                      SurfaceSportID?.surface?.id === "0"
                                      ? "0.4"
                                      : "1",
                                }}
                                value={date}
                                onChange={(e) => {
                                  handleDateChange(e.target.value);
                                }}
                                disabled={
                                  SurfaceSportID?.surface?.id === "" ||
                                  SurfaceSportID?.surface?.id === "0"
                                }
                              />
                              <span className="form-text invalid-feedback">
                                * This field is Required!
                              </span>
                            </div>
                            <div
                              className="col-6 parent position-relative"
                              ref={TimeRef}
                            >
                              <div
                                className="input-group"
                                onClick={handleTimeChange}
                                style={{
                                  opacity:
                                    SurfaceSportID?.surface?.id === "" ||
                                      SurfaceSportID?.surface?.id === "0"
                                      ? "0.4"
                                      : "1",
                                }}
                              >
                                <div
                                  className="form-control"
                                  id="TimeInput"
                                  style={{ background: "#F7F7F7" }}
                                >
                                  {selectedTimeSlots?.length === 0 ? (
                                    "-- : --"
                                  ) : (
                                    <span>
                                      {selectedTimeSlots[0]?.startTimeString}
                                    </span>
                                  )}
                                </div>
                                <span
                                  className="input-group-text"
                                  id="basic-time"
                                >

                                  {/* sun moon icons  */}
                                  {
                                    selectedTimeSlots?.length === 0 ? (
                                      <img
                                        src="/images/clock.svg"
                                        alt=""
                                        style={{ cursor: "pointer" }}
                                      />
                                    ) : (
                                      <span>
                                        <img
                                          src={getSlotIcon(
                                            selectedTimeSlots[0]?.startTime,
                                            selectedTimeSlots[0]?.startTimeString
                                          )}
                                          alt=""
                                          style={{
                                            cursor: "pointer",
                                            height: "18px",
                                            width: "18px",
                                          }}
                                        />
                                      </span>
                                    )
                                  }

                                </span>
                              </div>
                              <small className="d-none selectedtimeslots text-danger">
                                * This field is Required!
                              </small>
                              {showTimeList?.show && (
                                <Popup
                                  show={showTimeList?.show}
                                  venueflag={1}
                                  title={<h4>Choose start time</h4>}
                                  onHide={() =>
                                    setShowTimeList((prev) => ({
                                      ...prev,
                                      show: false,
                                    }))
                                  }
                                >
                                  <div className="time-dropdown ">
                                    {isTimeLoader ? (
                                      <div className="my-5">
                                        <Loader mt={20} />
                                      </div>
                                    ) : (
                                      <div
                                        className="filtersOpen mx-2"
                                      // style={{
                                      //   maxHeight: "150px",
                                      //   overflowY: "auto",
                                      // }}
                                      >
                                        <div className="row mx-0">
                                          {venueSlots?.length !== 0 ? (
                                            venueSlots
                                              ?.filter(
                                                (slot) =>
                                                  slot.startTime.split(
                                                    "T"
                                                  )[0] === date
                                              )
                                              ?.map((slots, i) => {
                                                const isSlotSelected =
                                                  selectedTimeSlots[0]
                                                    ?.startTimeString ===
                                                  slots?.startTimeString;

                                                return (
                                                  <div
                                                    className="col-6 py-1 px-1 my-1"
                                                    key={i}
                                                  >
                                                    <button
                                                      className={`citiesbox px-2 ${isSlotSelected
                                                          ? "slot-active"
                                                          : ""
                                                        }`}
                                                      onClick={() => {
                                                        handleTimeSlot(
                                                          slots,
                                                          venueSlots
                                                        );
                                                      }}
                                                      disabled={slots?.booked}
                                                      style={{
                                                        opacity: slots.booked
                                                          ? "0.3"
                                                          : "",
                                                      }}
                                                    >
                                                      <img
                                                        src={getSlotIcon(
                                                          slots?.startTime,
                                                          slots?.startTimeString
                                                        )}
                                                        alt=""
                                                        style={{
                                                          cursor: "pointer",
                                                          height: "18px",
                                                          width: "18px",
                                                        }}
                                                      />
                                                      {'  '}
                                                      {slots?.startTimeString}
                                                    </button>
                                                  </div>
                                                );
                                              })
                                          ) : (
                                            <div className="citiesbox border-0">
                                              No Time Slots available
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </Popup>
                              )}
                            </div>
                          </div>
                          {/*  <div className="row mt-3">
                            <div className="col-4 ">
                              <span className="venueText">Start Time</span>
                            </div>
                            <div
                              className="col-8 parent position-relative"
                              ref={TimeRef}
                            >
                              <div
                                className="input-group"
                                onClick={handleTimeChange}
                                style={{
                                  opacity:
                                    SurfaceSportID?.surface?.id === "" ||
                                    SurfaceSportID?.surface?.id === "0"
                                      ? "0.4"
                                      : "1",
                                }}
                              >
                                <div
                                  className="form-control"
                                  id="TimeInput"
                                  style={{ background: "#F7F7F7" }}
                                >
                                  {selectedTimeSlots?.length === 0 ? (
                                    "-- : --"
                                  ) : (
                                    <span>
                                      {selectedTimeSlots[0]?.startTimeString}
                                    </span>
                                  )}
                                </div>
                                <span
                                  className="input-group-text"
                                  id="basic-time"
                                >
                                  <img
                                    src="/images/clock.svg"
                                    alt=""
                                    style={{ cursor: "pointer" }}
                                  />
                                </span>
                              </div>
                              <small className="d-none selectedtimeslots text-danger">
                                * This field is Required!
                              </small>
                              {showTimeList?.show && (
                                <Popup
                                  show={showTimeList?.show}
                                  venueflag={1}
                                  title={<h4>Choose start time</h4>}
                                  onHide={() =>
                                    setShowTimeList((prev) => ({
                                      ...prev,
                                      show: false,
                                    }))
                                  }
                                >
                                  <div className="time-dropdown ">
                                    {isTimeLoader ? (
                                      <div className="my-5">
                                        <Loader mt={20} />
                                      </div>
                                    ) : (
                                      <div
                                        className="filtersOpen mx-2"
                                        // style={{
                                        //   maxHeight: "150px",
                                        //   overflowY: "auto",
                                        // }}
                                      >
                                        <div className="row mx-0">
                                          {venueSlots?.length !== 0 ? (
                                            venueSlots
                                              ?.filter(
                                                (slot) =>
                                                  slot.startTime.split(
                                                    "T"
                                                  )[0] === date
                                              )
                                              ?.map((slots, i) => {
                                                const isSlotSelected =
                                                  selectedTimeSlots[0]
                                                    ?.startTimeString ===
                                                  slots?.startTimeString;

                                                return (
                                                  <div
                                                    className="col-6 py-1 px-1 my-1"
                                                    key={i}
                                                  >
                                                    <button
                                                      className={`citiesbox px-2 ${
                                                        isSlotSelected
                                                          ? "slot-active"
                                                          : ""
                                                      }`}
                                                      onClick={() => {
                                                        handleTimeSlot(
                                                          slots,
                                                          venueSlots
                                                        );
                                                      }}
                                                      disabled={slots?.booked}
                                                      style={{
                                                        opacity: slots.booked
                                                          ? "0.3"
                                                          : "",
                                                      }}
                                                    >
                                                      {slots?.startTimeString}
                                                    </button>
                                                  </div>
                                                );
                                              })
                                          ) : (
                                            <div className="citiesbox border-0">
                                              No Time Slots available
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </Popup>
                              )}
                            </div> 
                          </div>*/}

                          {venueData?.category === "Events" && (
                            <>
                              <div className="row mt-3">
                                <div className="col-4 ">
                                  <span className="venueText">Purpose</span>
                                </div>
                                <div className="col-8">
                                  <select
                                    name="purpose"
                                    className="customize-select"
                                    value={selectedPurpose}
                                    onChange={(e) =>
                                      setPurpose(parseInt(e.target.value))
                                    }
                                  >
                                    <option value={0}>-- Select --</option>
                                    {courtData?.auditoriumEvents.map((item) => (
                                      <option key={item.id} value={item.id}>
                                        {item.name}
                                      </option>
                                    ))}
                                  </select>
                                  {purposeError && (
                                    <small className="text-danger">
                                      Please select atleast 1 Purpose from the
                                      dropdown list
                                    </small>
                                  )}
                                </div>
                              </div>
                              <div className="row mt-3">
                                <div className="col-4">
                                  <span className="venueText">
                                    No of people attending
                                  </span>
                                </div>
                                <div className="col-8">
                                  <input
                                    type="number"
                                    name="numberOfPeople"
                                    className="form-control custom-placeholder"
                                    min={1}
                                    max={
                                      courtData?.data[selectedSurfaceIndex]
                                        ?.maxcapacity
                                    }
                                    value={
                                      NumberOfPeople === null
                                        ? " "
                                        : NumberOfPeople
                                    }
                                    onChange={(e) => {
                                      setNumberOfPeopleAttending(
                                        e.target.value === ""
                                          ? ""
                                          : parseInt(e.target.value)
                                      );
                                    }}
                                  />
                                </div>
                                {peopleError === 1 && (
                                  <div className="offset-4 col-8">
                                    <small className="text-danger">
                                      The Max Capicity of{" "}
                                      {
                                        surfacetype[selectedSurfaceIndex]
                                          ?.surfacename
                                      }{" "}
                                      is{" "}
                                      {
                                        courtData?.data[selectedSurfaceIndex]
                                          ?.maxcapacity
                                      }
                                    </small>
                                  </div>
                                )}
                                {peopleError === 2 && (
                                  <div className="offset-4 col-8">
                                    <small className="text-danger">
                                      No of people attending can't be less than
                                      1
                                    </small>
                                  </div>
                                )}
                              </div>
                            </>
                          )}
                          <div
                            className="row mt-3"
                            style={{
                              display:
                                SurfaceSportID?.sport?.val != "Go-Karting"
                                  ? ""
                                  : "none",
                            }}
                          >
                            <div className="col-4 ">
                              <span className="venueText">Duration</span>
                            </div>
                            <div className="col-8 parent">
                              <div className="row align-items-center">
                                <div className="col-2 pe-0">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                    aria-hidden="true"
                                    class={`cursor-pointer br-50 ${slotDuration === MinSlotTime / 60
                                        ? "DisableDurationBtn"
                                        : "AddDurationBtn"
                                      }`}
                                    onClick={(e) => {
                                      if (slotDuration != MinSlotTime / 60) {
                                        setNextAvailableSlots(
                                          (count) => count + 1
                                        );
                                        setSlotDuration(
                                          (prevDuration) => prevDuration - 0.5
                                        );
                                        setSelectedTimeSlots((prevSelected) => [
                                          ...prevSelected.slice(0, -1),
                                        ]);
                                      }
                                      setCouponName("");
                                      setCouponData([]);
                                      setCouponApplied(false);
                                    }}
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      d="M3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                                      clip-rule="evenodd"
                                    ></path>
                                  </svg>
                                </div>
                                <div className="col-8 p-0 text-center">
                                  {convertDecimalToTime(slotDuration)}
                                </div>
                                <div className="col-2 ps-0 text-end">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                    aria-hidden="true"
                                    class={`${nextAvailableSlots === 0
                                        ? "DisableDurationBtn"
                                        : "AddDurationBtn"
                                      } ${isPackageBooking &&
                                      selectedPackageDuration <
                                      slotDuration + 0.5 &&
                                      "DisableDurationBtn"
                                      } cursor-pointer br-50`}
                                    onClick={(e) => {
                                      handleslotadditionchange(e);
                                    }}
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                                      clip-rule="evenodd"
                                    ></path>
                                  </svg>
                                </div>
                              </div>
                              <small className="form-text minSlotTimeError text-danger d-none">
                                <>
                                  Minimum{" "}
                                  {convertDecimalToTime(
                                    minToHour(venueData?.minSlotTime)
                                  )}{" "}
                                  booking is required{" "}
                                </>
                              </small>
                            </div>
                          </div>
                          {SurfaceSportID?.sport?.val &&
                            SurfaceSportID?.sport?.val === "Go-Karting" ? (
                            <>
                              <div className="row ">
                                <div className="col-4 mt-3">
                                  <span className="venueText">Duration</span>
                                </div>
                                <div className="col-8">
                                  <div className="row">
                                    {Duration?.map((item) => (
                                      <>
                                        <div className="col-md-4 col-6 parent position-relative mt-3 ">
                                          <div className="input-group ">
                                            <div
                                              className={`form-control text-center ${timeDuration === item?.time
                                                  ? "active-time"
                                                  : ""
                                                }`}
                                              id=""
                                              onClick={() => {
                                                setTimeDuration(item?.time);
                                                setSelectedTimeSlots([]);
                                                setSlotDuration(
                                                  venueData?.minSlotTime / 60
                                                );
                                                setNextAvailableSlots(0);
                                              }}
                                            >
                                              <span>{item?.time} Min</span>
                                            </div>
                                          </div>
                                        </div>
                                      </>
                                    ))}
                                  </div>
                                </div>
                              </div>
                              <div className="row mt-3">
                                <div className="col-4 ">
                                  <span className="venueText">No. of Cart</span>
                                </div>
                                <div className="col-8">
                                  <select
                                    className="customize-select"
                                    value={selectedCartCount}
                                    onChange={(e) =>
                                      setSelectedCartCount(e.target.value)
                                    }
                                  >
                                    {Array.from(
                                      { length: cartCount },
                                      (_, i) => i + 1
                                    ).map((num) => (
                                      <option key={num} value={num}>
                                        {num}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="row mt-1">
                              <div className="col-12">
                                <span className="fw-300">
                                  Minimum Booking of{" "}
                                  {convertDecimalToTime(
                                    venueData?.minSlotTime / 60
                                  )}{" "}
                                  is required
                                </span>
                              </div>

                              {/* <div className="col-8 parent position-relative">
                                <div className="input-group">
                                  {/* <div
                                    className="form-control"
                                    id=""
                                    style={{
                                      background: "#F7F7F7",
                                      opacity: "0.7",
                                    }}
                                  >
                                    <span>{MinSlotTime} Mins</span>
                                  </div> 
                                  <span>
                                    {convertDecimalToTime(
                                      venueData?.minSlotTime / 60
                                    )}
                                  </span>
                                </div>
                              </div> */}
                            </div>
                          )}
                          {!isPackageBooking && venueData?.isAcrive !== 6 && (
                            <>
                              {venuePrice > 0 && (
                                <>
                                  <hr />
                                  <div className="text-start">
                                    <label
                                      className="text-start"
                                      style={{
                                        fontSize: "16px",
                                        fontWeight: "500",
                                      }}
                                    >
                                      Price Breakup
                                    </label>
                                  </div>
                                  <div className="mt-2 d-flex justify-content-between align-items-center">
                                    <label
                                      style={{
                                        fontSize: "14px",
                                        color: "#7A7A7A",
                                      }}
                                    >
                                      Total Amount:
                                    </label>
                                    <span className="venueText">
                                      ₹
                                      {parseFloat(venuePrice ?? 0) +
                                        parseFloat(venueremainingPrice ?? 0) +
                                        parseFloat(discountAmount ?? 0) +
                                        parseFloat(venueconvenience ?? 0) +
                                        parseFloat(redeemBalance ? 50 : 0)}
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <label
                                      style={{
                                        fontSize: "14px",
                                        color: "#7A7A7A",
                                      }}
                                    >
                                      Pay at Venue:
                                    </label>
                                    <span className="venueText">
                                      ₹{venueremainingPrice}
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between align-items-center">
                                    <label
                                      style={{
                                        fontSize: "14px",
                                        color: "#7A7A7A",
                                      }}
                                    >
                                      Booking Amount:
                                    </label>
                                    <span className="venueText">
                                      ₹{venuePrice}
                                    </span>
                                  </div>

                                  <div className="d-flex justify-content-between">
                                    <label
                                      style={{
                                        fontSize: "14px",
                                        color: "#7A7A7A",
                                      }}
                                    >
                                      Service Charge:
                                    </label>
                                    <span className="venueText">
                                      ₹{venueconvenience}
                                    </span>
                                  </div>
                                  {walletBalance > 0 &&
                                    venueData?.id != 103 && (
                                      <div className="row mt-2">
                                        <div className="col-6 pe-0">
                                          <span
                                            style={{
                                              fontSize: "14px",
                                              color: "#7A7A7A",
                                            }}
                                          >
                                            Cricbuddy Balance
                                          </span>
                                        </div>
                                        <div className="col-6">
                                          <div className="venueText input-group d-flex align-items-center justify-content-end">
                                            <a
                                              className="cursor-pointer me-3"
                                              onClick={(e) => {
                                                if (redeemBalance) {
                                                  setredeemBalance(false);
                                                } else {
                                                  if (usePackageData) {
                                                    Swal.fire({
                                                      toast: true,
                                                      icon: "warning",
                                                      title: `Wallet balance can't be redeemed on package booking!`,
                                                      timer: 3000,
                                                      showConfirmButton: false,
                                                      position: "top",
                                                    });
                                                    return;
                                                  } else if (!couponApplied) {
                                                    if (venuePrice > 50) {
                                                      setredeemBalance(true);
                                                      setCouponApplied(false);
                                                      setCouponName("");
                                                      setCouponData([]);
                                                    } else {
                                                      Swal.fire({
                                                        toast: true,
                                                        icon: "warning",
                                                        title: `Price should be greater than ₹50`,
                                                        timer: 3000,
                                                        showConfirmButton: false,
                                                        position: "top",
                                                      });
                                                    }
                                                  } else {
                                                    Swal.fire({
                                                      toast: true,
                                                      icon: "warning",
                                                      title: `Coupon already applied! Can't use both at same time`,
                                                      timer: 3000,
                                                      showConfirmButton: false,
                                                      position: "top",
                                                    });
                                                  }
                                                }
                                              }}
                                            >
                                              {redeemBalance
                                                ? "remove"
                                                : "Redeem"}
                                            </a>
                                            ₹{walletBalance}
                                          </div>
                                          {redeemBalance && (
                                            <span className="form-text couponSuccess text-success">
                                              <>
                                                Woohoo! You Saved ₹
                                                {walletBalance > 0 && 50}
                                              </>
                                            </span>
                                          )}

                                          {/* <span className="form-text couponError d-none"></span> */}
                                        </div>
                                      </div>
                                    )}
                                  <hr />
                                </>
                              )}

                              <div className="row mt-3">
                                <div className="col-4 pe-0">
                                  <span className="venueText">Promo Code</span>
                                </div>
                                <div className="col-8">
                                  <div className="input-group">
                                    <input
                                      name="coupon"
                                      type="text"
                                      value={couponName}
                                      disabled
                                      onChange={(e) => {
                                        setCouponName(e.target.value);
                                      }}
                                      className="form-control custom-placeholder"
                                      autoComplete="off"
                                      placeholder="Coupon Code"
                                    />
                                    {/* <select className="customize-select form-control" value={couponName} onChange={(e) => {setCouponName(e.target.value)}}>
                                      {couponsData?.length === 0 ?
                                        <option>No Coupons Avalaible</option> :
                                        couponsData?.map((item) => (
                                          <option key={item.id} value={item.code}>
                                            {item.code}
                                          </option>
                                      ))}
                                    </select> */}
                                    <span
                                      className="input-group-text durationSelection cursor-pointer"
                                      onClick={(e) => {
                                        if (couponApplied) {
                                          setCouponName("");
                                          setCouponData([]);
                                          setCouponApplied(false);
                                        } else {
                                          if (!redeemBalance) {
                                            if (
                                              isLoggedIn === null ||
                                              isLoggedIn === ""
                                            ) {
                                              setShowPage({
                                                showLogin: true,
                                                userNameShow: false,
                                              });
                                            } else {
                                              setShowPage({
                                                showLogin: false,
                                                userNameShow: false,
                                              });
                                              applyCoupon("", venueData?.id);
                                            }
                                          } else {
                                            Swal.fire({
                                              toast: true,
                                              icon: "warning",
                                              title: `Referral Point's already used! Can't use both at same time`,
                                              timer: 3000,
                                              showConfirmButton: false,
                                              position: "top",
                                            });
                                          }
                                        }
                                      }}
                                    >
                                      {couponApplied ? "Remove" : "Apply"}
                                    </span>
                                  </div>

                                  {/* <span className="form-text couponSuccess text-success d-none">
                                    {showSuccess && (
                                      <>
                                        {" "}
                                        Woohoo! You just saved{" "}
                                        {couponData?.offPercentage}% with your
                                        coupon. You Saved ₹
                                        {discountAmount &&
                                          discountAmount?.toFixed(2)}
                                      </>
                                    )}
                                  </span> */}
                                  {date &&
                                    selectedTimeSlots.length > 0 &&
                                    slotDuration > 0 &&
                                    couponsData &&
                                    couponsData?.length !== 0 &&
                                    !couponApplied && (
                                      <div className="custom-fs-14 w-100 fw-600 text-end">
                                        <label
                                          className="text-success cursor-pointer text-decoration-underline"
                                          onClick={() =>
                                            setViewAllCoupon({
                                              ...showAllCoupon,
                                              show: true,
                                            })
                                          }
                                        >
                                          View Coupons
                                        </label>
                                      </div>
                                    )}

                                  {showAllCoupon?.show && (
                                    <UseModal
                                      isModalOpen={showAllCoupon?.show}
                                      heading={
                                        <h5 className="text-black fw-600">
                                          Choose a Coupon
                                        </h5>
                                      }
                                      handlePopUp={() =>
                                        setViewAllCoupon({
                                          ...showAllCoupon,
                                          show: false,
                                        })
                                      }
                                      size={"lg"}
                                      className={"text-black"}
                                      component={
                                        <div
                                          className={`${couponsData.length === 0
                                              ? "p-3"
                                              : ""
                                            }`}
                                        >
                                          {couponsData.length > 0 ? (
                                            <div className="d-flex flex-column gap-md-0 gap-3 pt-md-3">
                                              {[...couponsData]
                                                .sort((a, b) => {
                                                  const aInvalid =
                                                    invalidCoupons.includes(
                                                      a.code
                                                    );
                                                  const bInvalid =
                                                    invalidCoupons.includes(
                                                      b.code
                                                    );

                                                  if (aInvalid !== bInvalid) {
                                                    return aInvalid ? 1 : -1;
                                                  }

                                                  return (
                                                    new Date(a.createdAt) -
                                                    new Date(b.createdAt)
                                                  );
                                                })
                                                .map((item, index) => (
                                                  <div
                                                    className={`row p-3 p-md-4 mx-0 mx-md-3 mb-md-3 rounded applyCouponBg ${invalidCoupons.includes(
                                                      item.code
                                                    )
                                                        ? "opacity-50"
                                                        : "opacity-100"
                                                      }`}
                                                  >
                                                    <div className="col-12 col-md-8 px-0">
                                                      <div
                                                        key={index}
                                                        className="row mx-0 innerRow pb-3 py-md-2"
                                                      >
                                                        <div className="col-7 p-0 Montserrat custom-fs-12 fw-600 d-flex align-items-center gap-2">
                                                          <label className="text-nowrap">
                                                            Coupon Code:
                                                          </label>{" "}
                                                          <span className="heading-color">
                                                            {item.code}
                                                          </span>
                                                        </div>
                                                        {item?.sportNames
                                                          ?.length === 1 && (
                                                            <div className="col-5 mt-2 mt-md-0 d-flex justify-content-end p-0 Montserrat custom-fs-12 fw-600">
                                                              {item?.sportNames
                                                                ?.slice(0, 2)
                                                                .map(
                                                                  (sportName) => (
                                                                    <label
                                                                      className="p-md-1 ms-2"
                                                                      style={{
                                                                        border:
                                                                          "1px solid #E8E8E8",
                                                                        borderRadius:
                                                                          "50px",
                                                                      }}
                                                                    >
                                                                      <img
                                                                        src={`/images/${venueSportsData(
                                                                          sportName
                                                                        )}`}
                                                                        className="img-fluid"
                                                                        alt="image"
                                                                        title={
                                                                          sportName
                                                                        }
                                                                        style={{
                                                                          padding:
                                                                            "3px",
                                                                          height:
                                                                            "30px",
                                                                          width:
                                                                            "30px",
                                                                        }}
                                                                      />
                                                                    </label>
                                                                  )
                                                                )}
                                                            </div>
                                                          )}
                                                        {item.weekDays && (
                                                          <div className="d-flex flex-wrap p-0 mt-2 Montserrat custom-fs-12">
                                                            {item.weekDays
                                                              .split(",")
                                                              .map(
                                                                (d, i, arr) => (
                                                                  <span key={i}>
                                                                    {
                                                                      {
                                                                        1: "Mon",
                                                                        2: "Tue",
                                                                        3: "Wed",
                                                                        4: "Thu",
                                                                        5: "Fri",
                                                                        6: "Sat",
                                                                        7: "Sun",
                                                                      }[
                                                                      parseInt(
                                                                        d.trim()
                                                                      )
                                                                      ]
                                                                    }
                                                                    {i <
                                                                      arr.length -
                                                                      1 && (
                                                                        <span className="px-2 px-md-3 text-secondary">
                                                                          |
                                                                        </span>
                                                                      )}
                                                                  </span>
                                                                )
                                                              )}
                                                          </div>
                                                        )}
                                                        <div className="col-7 p-0 mt-2 Montserrat custom-fs-12">
                                                          <b>Timings :</b>{" "}
                                                          {item.offerStartTime ===
                                                            "00:00:00" &&
                                                            item.offerEndTime ===
                                                            "23:59:00" ? (
                                                            <span className="ms-1">
                                                              {" "}
                                                              Available for full
                                                              day
                                                            </span>
                                                          ) : (
                                                            <>
                                                              {convertTo12HourFormat(
                                                                item.offerStartTime
                                                              )}{" "}
                                                              -{" "}
                                                              {convertTo12HourFormat(
                                                                item.offerEndTime
                                                              )}
                                                            </>
                                                          )}
                                                        </div>
                                                        {item.duration > 0 && (
                                                          <div className="col-5 p-0 mt-2 Montserrat custom-fs-12">
                                                            <b>
                                                              Min Duration :
                                                            </b>{" "}
                                                            <span className="ms-1">
                                                              {item.duration}{" "}
                                                              hrs
                                                            </span>
                                                          </div>
                                                        )}
                                                        <div
                                                          className="col-12 p-0 mt-2 Montserrat custom-fs-12"
                                                          style={{
                                                            fontWeight: "500",
                                                          }}
                                                        >
                                                          <b>
                                                            Applicable for :
                                                          </b>{" "}
                                                          {
                                                            VenueDate(
                                                              item.createdAt
                                                            ).formattedDate
                                                          }{" "}
                                                          -{" "}
                                                          {
                                                            VenueDate(
                                                              item.expiry
                                                            ).formattedDate
                                                          }
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="col-12 col-md-4 px-0 mt-md-0 mt-3">
                                                      <div className="d-flex flex-row-reverse gap-3 gap-md-0 flex-md-column justify-content-start justify-content-md-center align-items-center w-100 h-100">
                                                        <button
                                                          className="booking px-3 px-md-5 py-1 py-md-2 border-0 rounded text-white Montserrat applyCouponBtn"
                                                          onClick={() => {
                                                            if (redeemBalance) {
                                                              Swal.fire({
                                                                toast: true,
                                                                icon: "warning",
                                                                title: `Wallet's Balance already used! Can't use both at same time`,
                                                                timer: 3000,
                                                                showConfirmButton: false,
                                                                position: "top",
                                                              });
                                                            } else {
                                                              setCouponName(
                                                                item.code
                                                              );
                                                              setViewAllCoupon({
                                                                ...showAllCoupon,
                                                                show: false,
                                                              });
                                                            }
                                                          }}
                                                          disabled={invalidCoupons.includes(
                                                            item.code
                                                          )}
                                                        >
                                                          Apply
                                                        </button>
                                                        {item.offPercentage !==
                                                          0 ? (
                                                          <label className="mt-md-2 heading-color fw-bold custom-fs-14">
                                                            {item.offPercentage}
                                                            % off{" "}
                                                            <span className=" fw-normal">
                                                              (upto Rs{" "}
                                                              {item.amountLimit}
                                                              )
                                                            </span>
                                                          </label>
                                                        ) : (
                                                          <label className="mt-md-2 heading-color custom-fs-14">
                                                            (upto Rs{" "}
                                                            {item.amountLimit})
                                                          </label>
                                                        )}
                                                      </div>
                                                    </div>
                                                  </div>
                                                ))}
                                            </div>
                                          ) : (
                                            <span className="text-black fw-600 Montserrat">
                                              No Coupons Available
                                            </span>
                                          )}
                                        </div>
                                      }
                                    />
                                  )}
                                  {couponData?.couponTypeId === 2 ? (
                                    <>
                                      {
                                        // couponError.errorId === 1 &&
                                        // selectedTimeSlots.length > 0 &&
                                        // slotDuration >= couponData?.duration &&
                                        // couponData?.amountLimit < venueremainingPrice &&
                                        // couponName !== "" &&
                                        couponApplied && (
                                          <span
                                            className="text-success"
                                            style={{ fontSize: "12px" }}
                                          >
                                            <>
                                              {" "}
                                              Woohoo! You just saved{" "}
                                              {couponData?.offPercentage}% with
                                              your coupon. You Saved ₹
                                              {discountAmount &&
                                                discountAmount?.toFixed(2)}
                                              {couponData?.code == "CBXMAS10"
                                                ? ", You have unlocked 2 New coupons."
                                                : null}
                                            </>
                                          </span>
                                        )
                                      }
                                    </>
                                  ) : (
                                    <>
                                      {
                                        // couponError.errorId === 1 &&
                                        // selectedTimeSlots.length > 0 &&
                                        // slotDuration >= couponData?.duration &&
                                        // couponData?.amountLimit < venueremainingPrice &&
                                        // couponName !== "" &&
                                        couponApplied && (
                                          <span
                                            className="text-success"
                                            style={{ fontSize: "12px" }}
                                          >
                                            <>
                                              {" "}
                                              Woohoo! You just saved ₹
                                              {couponData?.amountLimit} with
                                              your coupon.
                                            </>
                                          </span>
                                        )
                                      }
                                    </>
                                  )}

                                  {couponError.errorId === 2 && (
                                    <>
                                      <span
                                        className="text-danger"
                                        style={{ fontSize: "12px" }}
                                      >
                                        {couponError.errorMsg}
                                      </span>
                                      <br />
                                      {couponError.noteMsg && (
                                        <span
                                          className="text-warning"
                                          style={{ fontSize: "12px" }}
                                        >
                                          Note: {couponError.noteMsg}
                                        </span>
                                      )}
                                    </>
                                  )}

                                  {/* <span className="form-text couponError d-none"></span> */}
                                </div>
                              </div>
                            </>
                          )}
                          {!isPackageBooking &&
                            availablePackageData?.length > 0 &&
                            venueData?.isAcrive !== 6 && (
                              <div className="row mt-3 mx-0">
                                <div className="d-flex align-items-start justify-content-end form-check">
                                  <input
                                    type="checkbox"
                                    className="me-3 mt-2 form-check-input"
                                    id="packageBooking"
                                    checked={usePackageData}
                                    onClick={() => {
                                      setUsePackageData(!usePackageData);
                                      setCouponApplied(false);
                                      setShowSuccess(false);
                                      setredeemBalance(false);
                                      setCouponData([]);
                                    }}
                                    disabled={availablePackageData?.length < 1}
                                  />
                                  <label
                                    htmlFor="packageBooking"
                                    className="fw-500"
                                  >
                                    You own a package(
                                    {availablePackageData[0]?.name}) , use it to
                                    book
                                  </label>
                                </div>
                              </div>
                            )}
                        </div>

                        <div className="mt-3 text-center">
                          {/* {!isPackageBooking &&
                            (venueData?.isAcrive === 4 ||
                              venueData?.isAcrive === 5) && (
                              <div className="mb-3 text-success">
                                Convenience fee: {venueconvenience} Rs
                              </div>
                            )} */}
                          {venueData?.isAcrive === 4 ? (
                            <>
                              {!isPackageBooking ? (
                                <>
                                  <div
                                    className="d-flex justify-content-between align-items-center"
                                    style={{
                                      background: "#E7666A",
                                      padding: "10px",
                                      borderRadius: "8px",
                                    }}
                                  >
                                    <div
                                      className="text-start fw-500"
                                      style={{
                                        color: "white",
                                      }}
                                    >
                                      Confirm with ₹
                                      {!isPackageBooking &&
                                        !usePackageData &&
                                        `${parseInt(venuePrice) +
                                        parseInt(venueconvenience)
                                        }`}{" "}
                                      now.
                                      <br /> Pay ₹{venueremainingPrice} at the
                                      venue.
                                    </div>
                                    <div>
                                      <button
                                        className="bg-white border-0  p-2 fw-500"
                                        style={{
                                          borderRadius: "4px",
                                          color: "#E7666A",
                                          fontSize: "12px",
                                        }}
                                        onClick={() => {
                                          if (!isLoader) {
                                            setLoader(true);
                                            handlePayment();
                                          }
                                        }}
                                      >
                                        Book for{" "}
                                        {couponError.errorId === 1 &&
                                          parseInt(venuePrice) >
                                          parseInt(couponData?.amountLimit) ? (
                                          <>
                                            {!isPackageBooking &&
                                              !usePackageData &&
                                              `₹${parseInt(venuePrice) +
                                              parseInt(venueconvenience)
                                              }`}
                                            {/* `₹${parseInt(venuePrice) - parseInt(couponData?.amountLimit)}`} */}
                                          </>
                                        ) : (
                                          <>
                                            {!isPackageBooking &&
                                              !usePackageData &&
                                              `₹${parseInt(venuePrice) +
                                              parseInt(venueconvenience)
                                              }`}{" "}
                                          </>
                                        )}
                                      </button>
                                      {isLoader && (
                                        <img
                                          className="img-fluid ms-2"
                                          src="/images/loder.svg"
                                        />
                                      )}
                                    </div>
                                  </div>{" "}
                                </>
                              ) : (
                                <>
                                  <div>
                                    <button
                                      className="staff-button  p-2 fw-500"
                                      onClick={() => {
                                        if (!isLoader) {
                                          setLoader(true);
                                          handlePayment();
                                        }
                                      }}
                                    >
                                      Book Now{" "}
                                      {couponError.errorId === 1 &&
                                        parseInt(venuePrice) >
                                        parseInt(couponData?.amountLimit) ? (
                                        <>
                                          {!isPackageBooking &&
                                            !usePackageData &&
                                            `₹${parseInt(venuePrice) +
                                            parseInt(venueconvenience)
                                            }`}
                                          {/* `₹${parseInt(venuePrice) - parseInt(couponData?.amountLimit)}`} */}
                                        </>
                                      ) : (
                                        <>
                                          {!isPackageBooking &&
                                            !usePackageData &&
                                            `₹${parseInt(venuePrice) +
                                            parseInt(venueconvenience)
                                            }`}{" "}
                                        </>
                                      )}
                                    </button>
                                    {isLoader && (
                                      <img
                                        className="img-fluid ms-2"
                                        src="/images/loder.svg"
                                      />
                                    )}
                                  </div>
                                </>
                              )}
                            </>
                          ) : venueData?.isAcrive === 5 ? (
                            <>
                              {!isPackageBooking ? (
                                <>
                                  {" "}
                                  <div
                                    className="d-flex justify-content-between align-items-center"
                                    style={{
                                      background: "#E7666A",
                                      padding: "10px",
                                      borderRadius: "8px",
                                    }}
                                  >
                                    <div
                                      className="text-start fw-500"
                                      style={{
                                        color: "white",
                                      }}
                                    >
                                      Confirm with ₹
                                      {!isPackageBooking &&
                                        !usePackageData &&
                                        `${parseInt(venuePrice) +
                                        parseInt(venueconvenience)
                                        }`}{" "}
                                      now.
                                      <br /> Pay ₹{venueremainingPrice} at the
                                      venue.
                                    </div>
                                    <div>
                                      <button
                                        className="bg-white border-0  p-2 fw-500"
                                        style={{
                                          borderRadius: "4px",
                                          color: "#E7666A",
                                          fontSize: "12px",
                                        }}
                                        onClick={() => {
                                          !isLoader && handlerequest();
                                        }}
                                      >
                                        Book for{" "}
                                        {!isPackageBooking &&
                                          !usePackageData &&
                                          `₹${parseInt(venuePrice) +
                                          parseInt(venueconvenience)
                                          }`}{" "}
                                      </button>
                                      {isLoader && (
                                        <img
                                          className="img-fluid ms-2"
                                          src="/images/loder.svg"
                                        />
                                      )}
                                    </div>
                                  </div>
                                  <div className="d-flex mt-3">
                                    <input
                                      type="checkbox"
                                      name="bulkRequest"
                                      id="bulkRequest"
                                      className="form-check-input"
                                      checked={sendBulkRequest}
                                      onChange={(e) =>
                                        setSendBulkRequest(e.target.checked)
                                      }
                                    />
                                    <label
                                      htmlFor="bulkRequest"
                                      className="text-start ms-2 fw-500"
                                    >
                                      Also check availability of 5 nearby venues
                                    </label>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div>
                                    <button
                                      className="staff-button  p-2 fw-500"
                                      onClick={() => {
                                        !isLoader && handlerequest();
                                      }}
                                    >
                                      Book Now{" "}
                                      {!isPackageBooking &&
                                        !usePackageData &&
                                        `₹${parseInt(venuePrice) +
                                        parseInt(venueconvenience)
                                        }`}{" "}
                                    </button>
                                    {isLoader && (
                                      <img
                                        className="img-fluid ms-2"
                                        src="/images/loder.svg"
                                      />
                                    )}
                                  </div>
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              <button
                                className="venueListingTop booking  px-4 "
                                onClick={() => {
                                  !isLoader && handlerequest();
                                }}
                              >
                                <img
                                  className="me-2"
                                  src="/images/booking.svg"
                                  alt="book"
                                />
                                Request Booking
                              </button>
                              {isLoader && (
                                <img
                                  className="img-fluid ms-2"
                                  src="/images/loder.svg"
                                />
                              )}
                            </>
                          )}

                          {SurfaceSportID?.sport?.val === "Go-Karting" && (
                            <>
                              <div className="row text-start disclaimerbox py-3 mt-3 px-1">
                                <div className="col-12 text-center ">
                                  <b>Go-Karting Booking Disclaimer</b>
                                </div>
                                <div className="col-12 my-2">
                                  1. While online booking is recommended, venues
                                  do accept walk-in customers. This may result
                                  in a maximum 30-minute delay for online
                                  bookings; however, we prioritize online
                                  reservations whenever possible.
                                </div>
                                <div className="col-12">
                                  2. Please be aware that occasional delays may
                                  occur due to power outages or other technical
                                  difficulties.
                                </div>
                              </div>
                            </>
                          )}
                          {venueData?.id == process.env.REACT_APP_STUDIO_ID && (
                            <div className="mt-1 text-danger">
                              Booking slots are divided in before and after 7 pm
                              categories, booking is allowed in that format.
                            </div>
                          )}
                        </div>
                        {/* {!usePackageData &&
                          venueremainingPrice > 0 &&
                          venueData?.isAcrive !== 6 && (
                            <>
                              <div className="mt-2 text-center">
                                <label>Pay At Venue: </label>
                                <span>&nbsp;₹{venueremainingPrice}</span>
                              </div>
                              <div className="mt-2 text-center">
                                <label>Advance Amount: </label>
                                <span>
                                  &nbsp;
                                  {(
                                    (venuePrice * 100) /
                                    selectedTimeSlots.reduce(
                                      (acc, selectedSlot) =>
                                        acc + selectedSlot.price,
                                      0
                                    )
                                  ).toFixed(2) || 0}
                                  %
                                </span>
                              </div>
                            </>
                          )} */}
                      </div>
                      {venueData?.isAcrive === 5 && (
                        <div
                          className="mt-3 p-3"
                          style={{
                            textAlign: "justify",
                            border: "2px dashed red",
                          }}
                        >
                          <small>
                            <b>Important Note</b>
                            <br />
                            Venue manager will review your request and give
                            booking confirmation with-in {RequestTime} minutes.
                            Please do not close or press back button during the
                            process, we will keep you posted about process on
                            the screen.
                          </small>
                        </div>
                      )}
                      {!isPackageBooking &&
                        venueData?.isAcrive &&
                        (venueData?.isAcrive == 4 ||
                          venueData?.isAcrive == 5) && (
                          <>
                            <div className="row text-start disclaimerbox py-3 mt-3 mx-md-1">
                              <div className="col-12 text-center ">
                                <b>Payment Policy</b>
                              </div>
                              <div className="col-12 mt-2">
                                1.
                                {selectedTimeSlots.reduce(
                                  (acc, selectedSlot) =>
                                    acc + selectedSlot.price,
                                  0
                                ) > 0 &&
                                  (
                                    (venuePrice * 100) /
                                    selectedTimeSlots.reduce(
                                      (acc, selectedSlot) =>
                                        acc + selectedSlot.price,
                                      0
                                    )
                                  ).toFixed(2) > 0
                                  ? `To reserve your slot, simply pay a ${showVenueBookingContent
                                    ? (
                                      (venuePrice * 100) /
                                      selectedTimeSlots.reduce(
                                        (acc, selectedSlot) =>
                                          acc + selectedSlot.price,
                                        0
                                      )
                                    ).toFixed(2)
                                    : 0
                                  }% deposit at the time of booking. The remaining ${showVenueBookingContent
                                    ? (
                                      100 -
                                      (venuePrice * 100) /
                                      selectedTimeSlots.reduce(
                                        (acc, selectedSlot) =>
                                          acc + selectedSlot.price,
                                        0
                                      )
                                    ).toFixed(2)
                                    : 0
                                  }% can be paid conveniently when you arrive at the venue.`
                                  : "To reserve your slot, simply pay a deposit at the time of booking. The remaining balance can be paid conveniently when you arrive at the venue."}
                              </div>

                              <div className="col-12 my-2">
                                2.
                                {venueData?.cancellationTime > 0
                                  ? `According to this venue owner's policy, cancellation
                        is possible up to 
                        ${venueData?.cancellationTime > 48
                                    ? `${venueData.cancellationTime / 24} days`
                                    : `${venueData.cancellationTime} hours`
                                  } 
                        prior to the event, in this case a 100% refund
                        will be provided to the user.`
                                  : `This venue has a no-cancellation policy(You can't cancel once you've booked here)`}
                              </div>
                              {courtData?.data[selectedSurfaceIndex]
                                ?.extrahourecharge > 0 && (
                                  <div className="col-12">
                                    3.In case of extra hours you will be charged{" "}
                                    {
                                      courtData?.data[selectedSurfaceIndex]
                                        ?.extrahourecharge
                                    }{" "}
                                    rs per hour
                                  </div>
                                )}
                            </div>
                            <div className="row text-start disclaimerbox py-3 mt-3 mx-md-1">
                              <div className="col-12 text-center ">
                                <b>Reschedule Policy</b>
                              </div>
                              <div className="col-12 mt-2">
                                1.
                                {venueData?.rescheduleCount > 0
                                  ? `To reschedule the booking, the rescheduling
                              request must comply with the venue's rescheduling
                              policy, which allows for
                              ${venueData?.rescheduleCount} reschedules up to
                              ${venueData?.rescheduleHours} hours prior to the
                              event.`
                                  : "Rescheduling is not possible at this venue"}
                              </div>
                            </div>
                          </>
                        )}
                    </>
                  ) : showVenueBookingContent === 2 ? (
                    <>
                      <div className="row mt-2">
                        <div className="col-12">
                          <img
                            className="cursorClass"
                            src="/images/backArrow.svg"
                            onClick={() => {
                              setShowVenueBookingContent(1);
                              setLoader(false);
                            }}
                          />
                        </div>
                      </div>
                      <div className="row text-center mb-4">
                        <h1 className="text-center">Payment</h1>
                        <div
                          className="col-12 text-center"
                          style={{ fontSize: "20px" }}
                        >
                          You are booking
                        </div>
                        <div className="col-12 text-center">
                          <b style={{ fontSize: "26px" }}>{venueData.name}</b>
                        </div>
                        <div className="col-12 text-center">
                          {venueData.addresses}
                        </div>
                        {/* <div className="col-12 text-center">For playing</div> */}
                        <div className="col-12 text-center">
                          {/* <b>{SurfaceSportID.sport?.val}</b> */}
                          on {VenueDate(date).formattedDate}
                        </div>
                        <div className="col-12 text-center">
                          at {selectedTimeSlots[0].startTimeString} -{" "}
                          {
                            selectedTimeSlots[selectedTimeSlots.length - 1]
                              .endTimeString
                          }
                          {venueData?.isAcrive && (
                            <div className="col-12 text-center">
                              Pay ₹
                              {parseInt(venuePrice) +
                                parseInt(venueconvenience)}{" "}
                              (
                              {(
                                (parseInt(venuePrice) * 100) /
                                (parseInt(venuePrice) +
                                  parseInt(venueremainingPrice))
                              ).toFixed(2)}
                              %) now to secure your slot and
                            </div>
                          )}
                          {venueData?.isAcrive && (
                            <div className="col-12 text-center">
                              pay<b> ₹{venueremainingPrice} </b>at venue.
                            </div>
                          )}
                        </div>
                        <small className="d-none bookederror text-center text-danger w-100"></small>
                        <div className="mt-3">
                          <button
                            onClick={() => {
                              if (!isLoader) {
                                setLoader(true);
                                payNow("");
                              }
                            }}
                            className="venueListingTop booking w-75"
                          >
                            Pay Now (₹
                            {parseInt(venuePrice) + parseInt(venueconvenience)})
                          </button>{" "}
                          {isLoader && (
                            <img
                              className="img-fluid ms-2"
                              src="/images/loder.svg"
                            />
                          )}
                        </div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              )}

              <div>
                {paymentStatus.Status === "captured" && (
                  <div className="paymentSuccess mt-5 ">
                    <div className="text-end">
                      <a className="text-end" onClick={handlePrintCard}>
                        Print Reciept
                      </a>
                    </div>

                    <div className="mt-3" ref={cardRef}>
                      <div className="text-center">
                        <img
                          src="/images/correct.svg"
                          className="text-center"
                          alt=""
                        />

                        <h4 className="mt-3">Payment successful!</h4>
                        <p className="paymentText">
                          You can now visit and play.
                        </p>
                      </div>
                      <Card
                        className="mt-2"
                        style={{
                          borderRadius: "10px",
                          background: "white",
                          border: "none",
                          boxShadow: "0px 2px 2px 0px rgba(0, 0, 0, 0.25)",
                        }}
                      >
                        <Card.Body className="">
                          <div className="row">
                            <div className="col-5">
                              <span className="paymentText">Date : </span>
                            </div>
                            <div className="col-7">
                              <span className="paymentText fw-bold">
                                {VenueDate(date).formattedDate}
                              </span>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-5">
                              <span className="paymentText">Venue Name : </span>
                            </div>
                            <div className="col-7">
                              <span className="paymentText fw-bold">
                                {venueData?.name}
                              </span>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-5">
                              <span className="paymentText">
                                Venue Address :
                              </span>
                            </div>
                            <div className="col-7">
                              <span className="paymentText fw-bold">
                                {venueData?.addresses}
                              </span>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-5">
                              <span className="paymentText">Time : </span>
                            </div>
                            <div className="col-7">
                              <span className="paymentText fw-bold">
                                {selectedTimeSlots?.map(
                                  (selectedSlot, index) => (
                                    <>
                                      {index > 0 && <br />}
                                      {selectedSlot?.startTimeString}-
                                      {selectedSlot?.endTimeString}
                                    </>
                                  )
                                )}
                              </span>
                            </div>
                          </div>
                          <hr />
                          <div className="row">
                            <div className="col-5">
                              <span className="paymentText">
                                Order number :{" "}
                              </span>
                            </div>
                            <div className="col-7">
                              <span className="paymentText fw-bold">
                                {paymentStatus?.OrderID}
                              </span>
                            </div>
                          </div>
                          <div className="row">
                            <div
                              className="col-5 paymentText fw-bold"
                              style={{ color: "#4CAF50" }}
                            >
                              Amount paid:
                            </div>
                            <div
                              className="col-7 paymentText fw-bold"
                              style={{ color: "#4CAF50" }}
                            >
                              ₹{venuePrice}
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </div>
                    <div className="mt-5 mb-2">
                      <button
                        className="venueListingTop w-100 rounded-0 btn-danger"
                        // style={{ background: "#4CAF50" }}
                        onClick={(e) => {
                          window.localStorage.setItem(
                            "RedirectURL",
                            window.location.href
                          );
                          navigate("/venue-booking-details");
                        }}
                      >
                        View Bookings
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </>
      )}
      <Popup
        show={isBulkShow?.popup}
        hideModal={isBulkShow?.bookNow}
        onHide={() => {
          setIsBulkShow({ popup: false, bookingId: "", bookNow: false });
          setShow(false);
        }}
      >
        <BulkVenueRequest
          bookingId={isBulkShow?.bookingId}
          setIsBulkShow={setIsBulkShow}
          redirectUrl={`/nearme?location=${params?.id}&&time=${selectedTimeSlots[0]?.startTime}&&duration=${slotDuration}&&sport=${SurfaceSportID?.sport?.id}`}
        />
      </Popup>
    </>
  );
}
